/* Ardor SEG Display Designer: product (3ft / 10ft / 20ft SEG Display, 10ft SEG Backlit Display, 8ft / 10ft SEG Backlit
Popup Display, Wall Mount SEG, Custom SEG Fabric), then the supplier's option groups for that product in their wording and
order (hardware: Graphic + Frame or Graphic Only, sides, size, frame color, material; custom fabric: the width x height
typed in and Non-Lit / Backlit; wall mount: our portrait / landscape toggle, same price), quantity 1 to 10 (more = a quote),
delivery, live price, artwork on each printed face's template page (front, and the back on double sided displays), 3D
preview, signed proof, one print file in the supplier's template layout, cart and quote. Ardor Printing.
New Oct 19, 2026 (SEG-CORE). Made from a copy of the LIVE assets/ardor-realestate-builder.js (unchanged) by the patch list
seg/core/builder.patch, plus the ART0 lines (artwork by link + "Email me the proof to approve") of the live
assets/ardor-stand-builder.js. Loaded by sections/ardor-seg-builder-ws-kit.liquid.
One printed piece with up to two faces: 'front' and 'back' (S.face). A back shows "Same as front" or its own art
(S.backMode). Every face is drawn at true proportions from its print template (window.ArdorSegSpecs,
assets/ardor-seg-specs.js): the page (= the full fabric print size; the silicone edge is sewn inside it), the visible
area, the silicone edge band (goes into the frame), the 2 in bleed zone (background only), the dashed safe line(s) and,
on the backlit popups, the wrap panels (left side | front | right side) with their fold lines. Popup backs are their own,
smaller page (the front panel only); "Same as front" on a popup back uses the front panel of the front art.
Print file: ONE PDF page in the supplier's template layout (single sided = the face page; double sided = front and back
on one page, stacked, or side by side for the 3 ft; the 20 ft at the template's 50% scale; a wall mount hung landscape
keeps the listed W x H page with the art turned 90 degrees clockwise). Works with ardor-seg-layers-kit.js (text,
clipart, QR, backgrounds), ardor-seg3d.js (3D view) and ardor-seg-pdf.js (proof and print PDFs). No AI tools. */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- SEG displays, variants and prices ----------
  // One Shopify variant per display (or wall mount size), hardware (Graphic + Frame / Graphic Only) and sides. The section
  // writes every variant into the config: k = SKU ("SEG-<KEY>-<KIT|GO>-<1S|2S>-Q1", any letter case), o1 / o2 / o3 =
  // option values, id, c = price in cents, a = available. The cart line quantity = displays (1 to MAX_QTY; more is a
  // quote, because the supplier price does not drop with quantity). FALLBACK (window.ArdorSegSpecs.fallback, cents by
  // SKU) is only used when the config has no variants, so a price always shows; Add to cart then asks the customer to
  // call. Custom SEG Fabric has no fixed variants: its price comes from the size typed in (ArdorSegSpecs.cfPrice),
  // rounded up to the next whole dollar, and goes in the cart as that dollar's variant of the hidden price holder
  // product (assets/ardor-seg-prices.json: { product, min, max, ids }, ids[i] = the variant for $ min + i).
  var SPECS = window.ArdorSegSpecs || {};
  var KEYS = SPECS.keys || {};
  var FALLBACK = SPECS.fallback || {};
  var PACKS = SPECS.packs || {};
  var CUSTOM = SPECS.custom || {};
  var FAMS = (SPECS.fams || []).filter(function (f) { return f && f.keys && f.keys.length && f.groups; });
  var MAX_QTY = Math.max(1, Math.round(+((SPECS.qty || {}).max) || 10)); // displays in one online order; more is a quote
  var MAX_SIGNS = MAX_QTY;
  function maxQty() { return MAX_QTY; }
  var SAFE = 1; // inches inside the visible area for the dashed red safe line when the data gives none
  var MAX_FILE = 25 * 1024 * 1024;
  var PICKUP = CONF.pickup || '12531 Old Snohomish Monroe Rd., Snohomish, WA 98290';
  var NOFAM = { id: '', name: '', sub: '', short: 'display', keys: [], groups: [], dflt: {} };
  // group headings when the data leaves a label empty
  var GROUP_LABEL = { order: 'Hardware', sides: 'Sides', size: 'Size', orient: 'Hang it', lit: 'Graphic', fixed: 'Option' };

  var KEY_UC = {}; Object.keys(KEYS).forEach(function (k) { KEY_UC[k.toUpperCase()] = k; });
  // a sign key as written in the specs (sizes have a lowercase x: RP-24x18), any letter case accepted
  function normKey(s) { s = String(s || '').trim(); return KEYS[s] ? s : (KEY_UC[s.toUpperCase()] || ''); }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function famOf(id) { for (var i = 0; i < FAMS.length; i++) if (FAMS[i].id === id) return FAMS[i]; return NOFAM; }
  function famOfKey(key) { var e = KEYS[key]; return famOf(e ? e.fam : ''); }
  function realVals(g) { return (g.values || []).filter(function (v) { return !v.hdr; }); }
  function valOf(g, v) { var o = null; realVals(g).forEach(function (x) { if (x.v === v) o = x; }); return o; }
  function sizeGroup(fam) { return fam.groups.filter(function (g) { return g.role === 'size'; })[0] || null; }
  function sizeVal(fam, key) { var g = sizeGroup(fam), o = g ? realVals(g).filter(function (x) { return x.key === key; })[0] : null; return o ? o.v : ''; }
  // the supplier's own show / hide rules ("hardware != so", "size in 24x18,24x24")
  function shows(w, sel) {
    if (!w) return true;
    var cur = sel[w.g];
    if (w.op === '!=' || w.op === '!in') return w.v.indexOf(cur) < 0;
    return w.v.indexOf(cur) >= 0;
  }
  // the rider size a rider value stands for ('*' = the sign's own rider; '' = no rider)
  function riderOf(key, r) {
    var e = KEYS[key]; if (!r || !e || !e.riders) return '';
    if (r === '*') { var ks = Object.keys(e.riders); return ks[0] || ''; }
    return e.riders[r] ? r : '';
  }
  function valShows(key, g, v, sel) { return shows(v.when, sel) && !(g.role === 'rider' && v.rider && !riderOf(key, v.rider)); }
  // the picked value of every group, made valid for this sign: a hidden group has no value, a hidden or unknown value
  // falls back to the supplier's default, then to the first value that shows (two passes: rules can look ahead)
  function resolveSel(fam, key, want) {
    var sel = { size: sizeVal(fam, key) };
    for (var pass = 0; pass < 2; pass++) {
      fam.groups.forEach(function (g) {
        if (g.role === 'size') { sel[g.id] = sizeVal(fam, key); return; }
        if (!shows(g.when, sel)) { sel[g.id] = null; return; }
        var vis = realVals(g).filter(function (v) { return valShows(key, g, v, sel); });
        var w = want && want[g.id] != null ? want[g.id] : sel[g.id];
        var pick = vis.filter(function (v) { return v.v === w; })[0];
        // the supplier swaps the rider to the one that fits a new sign width (24 x 6 <-> 36 x 6): keep "a rider" picked
        if (!pick && g.role === 'rider' && w != null) { var wv = valOf(g, w); if (wv && wv.rider) pick = vis.filter(function (v) { return !!v.rider; })[0]; }
        pick = pick || vis.filter(function (v) { return v.v === fam.dflt[g.id]; })[0] || vis[0];
        sel[g.id] = pick ? pick.v : null;
      });
    }
    return sel;
  }
  // the combo code of a selection (the SKU between the key and -Q): order, then sides (yard sign), rider, pennant flag
  function comboOf(fam, key, sel) {
    var p = { order: 'KIT', sides: '1S', rider: '', flag: '' }, faces = 0, rider = '', flag = false;
    fam.groups.forEach(function (g) {
      var v = sel[g.id] == null ? null : valOf(g, sel[g.id]);
      if (!v) return;
      if (g.role === 'order') p.order = v.code || 'KIT';
      else if (g.role === 'sides') { faces = v.faces || 0; if (g.sku) p.sides = v.code || ''; }
      else if (g.role === 'rider') { rider = riderOf(key, v.rider); p.rider = 'R' + (rider || '0'); }
      else if (g.role === 'flag') { flag = v.code === 'FLAG'; p.flag = v.code || ''; }
    });
    return { order: p.order, code: [p.order, p.sides, p.rider, p.flag].filter(Boolean).join('-'), faces: faces, rider: rider, flag: flag };
  }
  function skuOf(key, code, pack) { return 'SEG-' + key + '-' + code + '-Q' + (pack || 1); }
  // the display key, combo code (KIT|GO-1S|2S) and pack of a variant: from its SKU, else from its option values
  function parseSku(k) {
    var m = /^SEG-((?:NL|BL|BP)-\d+FT|WM-\d+(?:\.\d+)?x\d+(?:\.\d+)?)-((?:KIT|GO)-(?:1S|2S))-Q(\d+)$/i.exec(String(k || '').trim());
    if (!m) return null;
    var key = normKey(m[1]);
    return key ? { key: key, code: m[2].toUpperCase(), pack: +m[3] } : null;
  }
  // a variant without a readable SKU (should not happen): option 1 names the display (the key's opt1), options 2 and 3
  // the hardware and the sides
  function fromOptions(v) {
    var o1 = String(v.o1 == null ? '' : v.o1).trim().toLowerCase().replace(/[“”″]/g, '"'), key = '';
    Object.keys(KEYS).forEach(function (k) { var e = KEYS[k]; if (!key && e && e.opt1 && String(e.opt1).toLowerCase().replace(/[“”″]/g, '"') === o1) key = k; });
    if (!key) return null;
    var t = [v.o2, v.o3].map(function (x) { return String(x == null ? '' : x).toLowerCase(); }).join(' | ');
    var code = (/graphic only/.test(t) ? 'GO' : 'KIT') + '-' + (/double/.test(t) ? '2S' : '1S');
    return FALLBACK[skuOf(key, code, 1)] != null ? { key: key, code: code, pack: 1 } : null;
  }
  var VAR = {}, LIVE = false;
  CONF.variants.forEach(function (v) {
    if (!v) return;
    var p = parseSku(v.k) || fromOptions(v);
    if (!p) return;
    var cents = Math.round(Number(v.c));
    VAR[p.key + '|' + p.code + '|' + p.pack] = { id: v.id || null, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || '') };
    LIVE = true;
  });
  // the variant Liquid selected (config "sofa": ?variant=<id>, or the first available one) is live data too, even when it
  // is past the first 250
  (function (v) {
    var p = v && v.id ? parseSku(v.k) : null; if (!p || !LIVE) return;
    var id = p.key + '|' + p.code + '|' + p.pack, cents = Math.round(Number(v.c));
    if (!VAR[id]) VAR[id] = { id: v.id, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || '') };
  })(CONF.sofa);
  var FB = {};
  Object.keys(FALLBACK).forEach(function (s) { var p = parseSku(s); if (p) FB[p.key + '|' + p.code + '|' + p.pack] = Math.round(Number(FALLBACK[s])) || 0; });
  // ---------- variants past the first 250 ----------
  // Liquid's product.variants lists the first 250 variants only. When the product has more (CONF.variantsCount), a variant
  // the specs price but the list lacks is read live: this section rendered for that variant's option values
  // (?option_values=<ids>&section_id=<id>, the same way sections/ardor-style-product.liquid does it); its config "sofa" is
  // that variant (id, SKU, live price, availability). The option values come from a listed variant of the same combo and
  // the Quantity value of the pack. Read once after load, and again before Add to cart if needed.
  var MORE = LIVE && (+CONF.variantsCount || 0) > (CONF.variants || []).length && !!CONF.sectionId;
  var LATE = {};
  function lateIds(key, code, pack) {
    var base = null;
    (CONF.variants || []).forEach(function (v) { var p = v && parseSku(v.k); if (!base && p && p.key === key && p.code === code && v.o1 != null) base = [v.o1, v.o2, v.o3]; });
    if (!base) return null;
    var opts = CONF.options || [], ids = [];
    for (var i = 0; i < opts.length; i++) {
      var vals = opts[i] || [], hit = null;
      var isQty = vals.length > 0 && vals.every(function (x) { return /^\d+\s*signs?$/i.test(String(x[1]).trim()); });
      vals.forEach(function (x) { if (!hit && (isQty ? +String(x[1]).match(/\d+/)[0] === pack : String(x[1]) === String(base[i]))) hit = x; });
      if (!hit || hit[0] == null) return null;
      ids.push(hit[0]);
    }
    return ids.length ? ids : null;
  }
  function readLate(key, code, pack) {
    code = String(code || '').toUpperCase(); pack = +pack || 1;
    var id = key + '|' + code + '|' + pack;
    if (VAR[id]) return Promise.resolve(VAR[id]);
    if (LATE[id]) return LATE[id];
    var ids = MORE ? lateIds(key, code, pack) : null;
    if (!ids || !window.fetch || !window.DOMParser) return Promise.reject(new Error('no variant'));
    var base = String(CONF.productUrl || window.location.pathname);
    var url = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'option_values=' + ids.join(',') + '&section_id=' + encodeURIComponent(CONF.sectionId);
    LATE[id] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html'), el = d.querySelector('[data-abb-config]');
      var cf = el ? JSON.parse(el.textContent) : null, v = cf && cf.sofa, p = v && parseSku(v.k);
      if (!p || p.key + '|' + p.code + '|' + p.pack !== id || !v.id) throw new Error('variant not found');
      var cents = Math.round(Number(v.c));
      VAR[id] = { id: v.id, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || ''), late: true };
      return VAR[id];
    });
    LATE[id].then(function () { if (typeof render === 'function') render(); }, function () { delete LATE[id]; });
    return LATE[id];
  }
  // the variant for a sign, combo and pack. none = the product has no such variant (not offered)
  function variantFor(key, code, pack) {
    var id = key + '|' + String(code || '').toUpperCase() + '|' + (+pack || 1);
    if (VAR[id]) return VAR[id];
    if (LIVE && MORE && FB[id]) return { id: null, cents: FB[id], available: true, pending: true, sku: skuOf(key, String(code || '').toUpperCase(), +pack || 1) };
    if (LIVE) return { id: null, cents: 0, available: false, none: true, sku: '' };
    var x = FB[id] || 0;
    return { id: null, cents: x, available: false, none: !x, sku: x ? skuOf(key, code, pack) : '' };
  }
  // the pack sizes a sign and combo can be ordered in (1 = single signs), smallest first
  function packsFor(key, code) {
    var ps = (PACKS[key] || [1]).slice();
    if (LIVE) Object.keys(VAR).forEach(function (id) { var p = id.split('|'); if (p[0] === key && ps.indexOf(+p[2]) < 0) ps.push(+p[2]); });
    ps.sort(function (a, b) { return a - b; });
    return ps.filter(function (q) { return !variantFor(key, code, q).none; });
  }
  // every selection the picker can make for a sign (each group with a choice, every value), made valid
  function allSels(fam, key) {
    var gs = fam.groups.filter(function (g) { return g.role !== 'size' && realVals(g).length > 1; }), out = [];
    (function rec(i, want) {
      if (i === gs.length) { out.push(resolveSel(fam, key, want)); return; }
      realVals(gs[i]).forEach(function (v) { var w = Object.assign({}, want); w[gs[i].id] = v.v; rec(i + 1, w); });
    })(0, {});
    return out;
  }
  var CODES = {};
  function codesFor(key) {
    if (CODES[key]) return CODES[key];
    var fam = famOfKey(key), seen = {}, out = [];
    allSels(fam, key).forEach(function (sel) { var cb = comboOf(fam, key, sel); if (!seen[cb.code]) { seen[cb.code] = 1; out.push(cb.code); } });
    return (CODES[key] = out);
  }
  function keyOffered(key) { if (isCustom(key)) return !!KEYS[key]; return codesFor(key).some(function (cd) { return packsFor(key, cd).length > 0; }); }
  function keysShown(fam) { return (fam.keys || []).filter(function (k) { return KEYS[k] && keyOffered(k); }); }
  function famsShown() { return FAMS.filter(function (f) { return keysShown(f).length > 0; }); }

  // ---------- print template geometry (per face: the front page, and the back page of a double sided display) ----------
  // Inches from the page's top-left (y down). The page = the full fabric print size (the silicone edge is sewn inside it):
  // vis = what shows when the display is up, hidden k:'edge' = the silicone edge band (goes into the frame), zone = the
  // 2 in bleed zone (background only, may be trimmed), safe / safes = the dashed safe line(s), panels + folds = the popup
  // wrap (left side | front | right side). Popup backs have their own, smaller page (the front panel only; fromFront =
  // the part of the front page that "Same as front" uses). Custom fabric: the size typed in (page = the visible graphic,
  // the supplier's rule). A wall mount hung landscape: the listed W x H page turned 90 degrees clockwise.
  var GEO = {};
  function R4(a) { return a && a.length === 4 && a.every(function (x) { return isFinite(+x); }) ? a.map(Number) : null; }
  function rectPts(r) { return [[r.x, r.y], [r.x + r.w, r.y], [r.x + r.w, r.y + r.h], [r.x, r.y + r.h]]; }
  function isCustom(key) { return !!(key && KEYS[key] && KEYS[key].custom); }
  // square sizes never turn: no Hang it toggle when the page is W = H (QA Oct 20, 2026)
  function turnable(key) { var e = KEYS[key]; return !!(e && e.orient && e.orient.turnable) && !(e.front && Math.abs(Number(e.front.W) - Number(e.front.H)) < 0.001); }
  // the template of a face: the key's front page (or its own back page); custom fabric made from the size typed in
  function specOf(key, back) {
    var e = KEYS[key] || {};
    if (isCustom(key)) {
      var cf = CUSTOM[key] || CUSTOM.CF || {}, w = S.cw, h = S.ch, sf = Math.min(num(cf.safeIn, 1), w / 4, h / 4);
      return { W: w, H: h, vis: [0, 0, w, h], faces: 1, zone: num(cf.zone, 0), safe: [sf, sf, w - 2 * sf, h - 2 * sf], hidden: [], material: cf.material || '' };
    }
    return (back ? (e.back || e.front || e.sign) : (e.front || e.sign)) || null;
  }
  function pieceSpec(key, piece, rider) { return specOf(key, false); }
  function geoFor(key, piece, rider, back, ori) {
    var cust = isCustom(key), turn = ori === 'landscape' && turnable(key) && !cust;
    var id = [key, back ? 'b' : 'f', turn ? 'L' : 'P', cust ? S.cw + 'x' + S.ch : ''].join('|');
    if (GEO[id]) return GEO[id];
    var t = specOf(key, back) || { W: 24, H: 18 };
    var W0 = +t.W || 24, H0 = +t.H || 18;
    // hung landscape: every rect turned 90 degrees clockwise, (x, y) -> (H0 - y, x)
    var tr = function (r) { return turn ? [H0 - r[1] - r[3], r[0], r[3], r[2]] : r; };
    var W = turn ? H0 : W0, H = turn ? W0 : H0;
    var v = R4(t.vis) ? tr(R4(t.vis)) : [0, 0, W, H];
    var box = function (z) { var r = R4(z && (z.r || z.rect)); if (!r) return null; r = tr(r); return { x: r[0], y: r[1], w: r[2], h: r[3] }; };
    var g = { W: W, H: H, W0: W0, H0: H0, turned: turn, bleed: 0, piece: 'sign', rider: '', placeholder: false, faces: +t.faces === 2 ? 2 : 1,
      vis: { x: v[0], y: v[1], w: v[2], h: v[3] },
      hidden: (t.hidden || []).map(function (z) { var r = box(z); return r ? Object.assign(r, { why: String(z.why || 'Silicone edge - goes into the frame'), k: String(z.k || '') }) : null; }).filter(Boolean),
      keep: (t.keep || []).map(function (z) { var r = box(z); return r ? Object.assign(r, { why: 'Keep clear' }) : null; }).filter(Boolean),
      holes: [], holeKind: 'hole', flutes: null, material: t.material || '', zone: Math.max(0, num(t.zone, 0)),
      trim: { x: 0, y: 0, w: W, h: H }, grommets: [], pockets: [] };
    var sr = R4(t.safe) ? tr(R4(t.safe)) : null;
    g.safeR = sr ? { x: sr[0], y: sr[1], w: sr[2], h: sr[3] } : { x: g.vis.x + SAFE, y: g.vis.y + SAFE, w: Math.max(1, g.vis.w - 2 * SAFE), h: Math.max(1, g.vis.h - 2 * SAFE) };
    var safes = (Array.isArray(t.safes) ? t.safes : []).map(function (s) { var r = R4(s && (s.r || s.rect || s)); if (!r) return null; r = tr(r); return { x: r[0], y: r[1], w: r[2], h: r[3], label: String((s && s.label) || ''), id: String((s && s.id) || '') }; }).filter(Boolean);
    g.safes = safes.length ? safes : [Object.assign({ label: '', id: 'front' }, g.safeR)];
    g.safeIn = SAFE;
    g.cut = rectPts(g.trim); g.cutPoly = false;
    g.safe = g.safes.map(rectPts);
    // popup wrap panels and folds (popups are never turned)
    g.panels = turn ? [] : (t.panels || []).map(function (p) { return { id: String(p.id || ''), x: num(p.x, 0), w: num(p.w, 0), label: String(p.label || '') }; }).filter(function (p) { return p.w > 0; });
    g.folds = turn ? [] : (t.folds || []).map(function (f) { return typeof f === 'number' ? f : num(f && f.x, NaN); }).filter(function (x) { return isFinite(x); });
    g.fromFront = R4(t.fromFront);
    g.face = [g.vis.x, g.vis.y, g.vis.x + g.vis.w, g.vis.y + g.vis.h];
    g.bx = g.vis.x; g.by = g.vis.y; g.bw = g.vis.w; g.bh = g.vis.h;
    return (GEO[id] = g);
  }
  // face ids: 'front', 'back' (the rider faces of the copied code stay idle: no SEG key has a rider)
  var FACES = ['front', 'back', 'rider-front', 'rider-back'];
  function pieceOf(f) { return /^rider/.test(String(f || '')) ? 'rider' : 'sign'; }
  function isBack(f) { return /back/.test(String(f || '')); }
  function fid(piece, side) { return (piece === 'rider' ? 'rider-' : '') + (side === 'back' ? 'back' : 'front'); }
  function normFace(f) { f = String(f || '').replace(/-flat$/, ''); return FACES.indexOf(f) >= 0 ? f : 'front'; }
  // cfg() for one face: its page (the back page only on a double sided order)
  function fo(f) { f = normFace(f); return { piece: pieceOf(f), face: isBack(f) ? 'back' : 'front' }; }
  // the geometry of a face of this order: the front page, or the back page of a double sided order
  function faceGeo(c, face) {
    return geoFor(c.key, 'sign', '', isBack(face) && c.sides === 2, c.orient);
  }
  // a popup back showing "Same as front": the front panel of the front art (the back page is smaller than the wrap).
  // Returns null when this is not such a back, else whether anything was drawn.
  function popCrop(ctx, Wi, Hi, face) {
    if (!isBack(face) || backShown('sign')) return null;
    var c0 = cfg();
    if (!c0.popBack) return null;
    var fg = c0.sign.geo, cr = (c0.sign.bgeo && c0.sign.bgeo.fromFront) || [(fg.W - Wi) / 2, (fg.H - Hi) / 2, Wi, Hi];
    if (!artFor('front') && !hasLayers('front')) return false;
    if (lay.canvas && ctx.canvas === lay.canvas) {
      // the 2D view: the layers are drawn by the live overlay only there, so copy the front's 3D face picture instead
      var fcv = paintFaceCanvas(c0, 'front'); if (!fcv) return false;
      var kx = fcv.width / fg.W, ky = fcv.height / fg.H;
      ctx.drawImage(fcv, cr[0] * kx, cr[1] * ky, Wi * kx, Hi * ky, 0, 0, Wi, Hi);
      return true;
    }
    ctx.save(); ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.clip();
    ctx.translate(-cr[0], -cr[1]);
    var ok = paintFace(ctx, fg.W, fg.H, 'front');
    ctx.restore();
    return ok;
  }

  var S = { fam: '', key: '', sel: {}, pack: 1, qty: 1, delivery: 'ship', piece: 'sign', face: 'front', back: false, backMode: 'same', rBackMode: 'same', artVer: 0, cw: 96, ch: 48 };
  var ART = { front: null, back: null, 'rider-front': null, 'rider-back': null };
  if (MORE) setTimeout(function () {
    var n = 0;
    Object.keys(FB).forEach(function (id) { if (VAR[id] || n >= 12) return; n++; var q = id.split('|'); readLate(q[0], q[1], +q[2]).catch(function () {}); });
  }, 1200);
  var eng = null;
  (function () {
    // ?variant=<id> (Google Shopping, Shopify variant links) opens that exact variant: display, hardware and sides,
    // quantity 1. A link to one display (?display=<KEY>, any letter case) opens on it, and wins when it names another
    // display. Else the section's default display. ?preset= (the shared assets/ardor-designer-preset.js) runs after this,
    // so it still wins. Custom fabric sizes come in as ?preset=...,cw:<in>,ch:<in>: read here (the shared script only
    // clicks buttons). The AI hand-off (?ai=) is not used by this designer.
    var cfd = famOf('cf').dflt || {};
    S.cw = num(cfd.cw, 96); S.ch = num(cfd.ch, 48);
    var want = normKey(CONF.defaultDisplay), q = '', qs = null, qv = null;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { qs = null; }
    var pre = qs ? String(qs.get('preset') || '') : '';
    pre.split(',').forEach(function (pair) {
      var i = pair.indexOf(':'), k = i < 0 ? '' : pair.slice(0, i).trim(), v = i < 0 ? NaN : parseFloat(pair.slice(i + 1));
      if (!(v > 0)) return;
      if (k === 'cw') S.cw = v; else if (k === 'ch') S.ch = v;
    });
    var fx0 = cfFix(S.cw, S.ch); S.cw = fx0[0]; S.ch = fx0[1];
    var vid = qs ? String(qs.get('variant') || '').trim() : '';
    if (pre) vid = ''; // a preset sets the order itself
    if (/^\d+$/.test(vid)) {
      (CONF.variants || []).concat(CONF.sofa ? [CONF.sofa] : []).forEach(function (v) { if (!qv && v && String(v.id) === vid) qv = parseSku(v.k) || fromOptions(v); });
      if (qv && keysShown(famOfKey(qv.key)).indexOf(qv.key) >= 0) want = qv.key; else qv = null;
    }
    q = qs ? normKey(qs.get('display') || '') : '';
    if (!q && qs && qs.get('display')) { var fq = famOf(String(qs.get('display')).trim().toLowerCase()); if (fq.id) q = keysShown(fq)[0] || ''; } // ?display=<family id> also works (nl10, wm, cf ...)
    if (q && keysShown(famOfKey(q)).indexOf(q) >= 0 && (!qv || q !== qv.key)) { want = q; qv = null; }
    var fams = famsShown(), f = want ? famOfKey(want) : (fams[0] || NOFAM);
    var ks = keysShown(f);
    S.key = ks.indexOf(want) >= 0 ? want : (ks[0] || '');
    S.fam = f.id;
    if (qv && S.key === qv.key) {
      var hit = allSels(f, S.key).filter(function (sel) { return comboOf(f, S.key, sel).code.toUpperCase() === String(qv.code).toUpperCase(); })[0];
      if (hit) { S.sel = hit; S.pack = qv.pack; S.qty = 1; }
    }
  })();

  // ---------- custom SEG fabric: the size typed in, its price and the price holder variant ----------
  var CFP = null, cfpP = null; // assets/ardor-seg-prices.json: { product, min, max, ids[] } (ids[i] = the variant for $ min + i)
  function cfConf() { return CUSTOM.CF || {}; }
  function cfLimits() { var c = cfConf(); return { min: num(c.minIn, 1), long: num(c.maxLong, 480), short: num(c.maxShort, 120) }; }
  // a size made valid: each side at least the minimum, the long side at most 480 in, the short side at most 120 in
  function cfFix(w, h) {
    var L = cfLimits(); w = Math.max(L.min, num(w, 96)); h = Math.max(L.min, num(h, 48));
    w = Math.min(w, L.long); h = Math.min(h, L.long);
    if (Math.min(w, h) > L.short) { if (w <= h) w = L.short; else h = L.short; }
    return [Math.round(w * 100) / 100, Math.round(h * 100) / 100];
  }
  function cfError(w, h) {
    if (typeof SPECS.cfCheck === 'function') { try { return SPECS.cfCheck(w, h) || ''; } catch (e) {} }
    var L = cfLimits(); w = +w; h = +h;
    if (!(w > 0) || !(h > 0)) return 'Enter a width and a height.';
    if (Math.min(w, h) < L.min) return 'Each side must be at least ' + L.min + ' in.';
    if (Math.max(w, h) > L.long || Math.min(w, h) > L.short) return 'The largest size is 480 x 120 in (40 x 10 ft), either way.';
    return '';
  }
  // the price of a custom size: cents = the formula price, whole = what is charged (the next whole dollar)
  function cfQuote(w, h, graphic) {
    var lit = graphic === 'backlit' ? 'backlit' : 'nonlit', err = cfError(w, h);
    if (err) return { w: w, h: h, graphic: lit, err: err, cents: 0, whole: 0, sku: '', sqft: 0 };
    var r = null;
    if (typeof SPECS.cfPrice === 'function') { try { r = SPECS.cfPrice(w, h, lit); } catch (e) { r = null; } }
    if (!r) { // the same rule as the data file: 2 x (supplier cost + ground shipping)
      var c = cfConf(), rate = (c.rate || {})[lit] || (lit === 'backlit' ? 1.75 : 1.09), sq = w * h / 144;
      var costC = Math.max(Math.round(num(c.min, 30) * 100), Math.floor(sq * rate * 100 + 0.5 + 1e-7));
      var sh = c.ship || [[200, 19.49], [400, 22.03]], ship = sh[sh.length - 1][1];
      for (var i = 0; i < sh.length; i++) { if (sq <= sh[i][0] + 1e-9) { ship = sh[i][1]; break; } }
      var cents = num(c.mult, 2) * (costC + Math.round(ship * 100)), hd = c.holder || {};
      var whole = Math.min(Math.max(Math.ceil(cents / 100), num(hd.min, 99)), num(hd.max, 1445));
      r = { sqft: Math.round(sq * 100) / 100, cents: cents, whole: whole, sku: (hd.skuPrefix || 'SEG-CF-USD') + whole };
    }
    return { w: w, h: h, graphic: lit, err: '', cents: r.cents, whole: r.whole, sku: r.sku, sqft: r.sqft };
  }
  function cfVariant(qt) {
    if (!qt || qt.err || !(qt.whole > 0)) return { id: null, cents: 0, available: false, none: true, sku: '', custom: true };
    var id = CFP && CFP.ids ? CFP.ids[qt.whole - (+CFP.min || 0)] : null;
    return { id: id || null, cents: qt.whole * 100, available: !!id, sku: qt.sku, custom: true, pending: !CFP };
  }
  function loadCfp() {
    if (CFP) return Promise.resolve(CFP);
    if (cfpP) return cfpP;
    if (!CONF.cfPricesUrl || !window.fetch) return Promise.reject(new Error('no price list'));
    cfpP = fetch(CONF.cfPricesUrl, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function (j) {
      if (!j || !Array.isArray(j.ids) || !j.ids.length) throw new Error('price list');
      CFP = j;
      if (typeof render === 'function') render();
      return CFP;
    });
    cfpP.catch(function () { cfpP = null; });
    return cfpP;
  }

  // c.Wi x c.Hi = the page of the face being edited (c.face: the front page, or the back page of a double sided order;
  // popups have a smaller back page). c.sign.geo = the front page, c.sign.bgeo = the back page. c.qty = displays.
  // c.sel = the picked value of every supplier option group (+ our wall mount orientation).
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var fams = famsShown(), fam = famOf(s.fam);
    if (fams.indexOf(fam) < 0) fam = (s.key && fams.indexOf(famOfKey(s.key)) >= 0) ? famOfKey(s.key) : (fams[0] || NOFAM);
    var ks = keysShown(fam), key = ks.indexOf(s.key) >= 0 ? s.key : (ks[0] || fam.keys[0] || '');
    var cust = isCustom(key);
    var sel = resolveSel(fam, key, s.sel || {}), cb = comboOf(fam, key, sel);
    if (!cust && !packsFor(key, cb.code).length) { // a combo with no price: the nearest one that has one
      var alt = allSels(fam, key).filter(function (x) { return packsFor(key, comboOf(fam, key, x).code).length > 0; })[0];
      if (alt) { sel = alt; cb = comboOf(fam, key, sel); }
    }
    var e = KEYS[key] || {};
    var qty = Math.max(1, Math.min(MAX_QTY, Math.round(Number(s.qty)) || 1));
    var orient = sel.orient === 'landscape' && turnable(key) ? 'landscape' : 'portrait';
    var c = { fam: fam, famId: fam.id, cat: fam.cat || '', key: key, e: e, st: e, sel: sel, combo: cb.code, order: cust ? 'GO' : cb.order, flag: false, pack: 1, packs: [1],
      qty: qty, delivery: s.delivery === 'pickup' ? 'pickup' : 'ship', riderSize: '', artVer: s.artVer, orient: orient, custom: cust,
      graphic: cust ? (sel.graphic === 'backlit' ? 'backlit' : 'nonlit') : '' };
    c.lit = cust ? c.graphic === 'backlit' : !!(e.hw && e.hw.lit);
    c.cf = cust ? cfQuote(S.cw, S.ch, c.graphic) : null;
    c.v = cust ? cfVariant(c.cf) : variantFor(key, cb.code, 1);
    var sides = cust ? 1 : (cb.faces || 1);
    c.sign = { piece: 'sign', sides: sides, geo: geoFor(key, 'sign', '', false, orient) };
    c.sign.bgeo = sides === 2 ? geoFor(key, 'sign', '', true, orient) : c.sign.geo;
    c.sign.Wi = c.sign.geo.W; c.sign.Hi = c.sign.geo.H;
    c.rider = null;
    c.sides = sides; c.rsides = 0;
    c.piece = 'sign';
    c.face = s.face === 'back' && sides === 2 ? 'back' : 'front';
    c.geo = c.face === 'back' ? c.sign.bgeo : c.sign.geo; c.Wi = c.geo.W; c.Hi = c.geo.H; c.pieceSides = sides;
    c.W = c.Wi / 12; c.H = c.Hi / 12; // feet, for shared kit code that reads them
    c.bm = { sign: s.backMode === 'different' ? 'different' : 'same', rider: 'same' };
    c.backMode = c.bm.sign;
    c.popBack = sides === 2 && (Math.abs(c.sign.bgeo.W - c.sign.geo.W) > 0.01 || Math.abs(c.sign.bgeo.H - c.sign.geo.H) > 0.01);
    return c;
  }
  // the faces that get their own print file: the sign front, its back when it has its own art, the rider front and the
  // rider's back when it has its own art
  function printedFaces(c) {
    var out = ['front'];
    if (c.sides === 2 && c.bm.sign === 'different') out.push('back');
    if (c.rider) { out.push('rider-front'); if (c.rsides === 2 && c.bm.rider === 'different') out.push('rider-back'); }
    return out;
  }
  // each = one display (custom fabric: the size's whole-dollar price); charged = what goes in the cart
  function price(c) {
    var each = c.v.cents / 100;
    return { each: each, charged: each * c.qty, unit: each, vid: c.v.id, disc: 0 };
  }
  // the lowest price a display can be ordered for, optionally for combos passing test
  function fromKey(key, test) {
    if (isCustom(key)) { var hd = cfConf().holder || {}; return Math.round(num(hd.min, 99) * 100); }
    var lo = 0;
    codesFor(key).forEach(function (cd) { if (test && !test(cd)) return; var ps = packsFor(key, cd); if (!ps.length) return; var v = variantFor(key, cd, ps[0]); if (v.cents > 0 && (!lo || v.cents < lo)) lo = v.cents; });
    return lo;
  }
  function famFrom(fam) { var lo = 0; keysShown(fam).forEach(function (k) { var x = fromKey(k); if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }
  // the price of the order with one group's value changed (0 = not offered)
  function priceWith(c, g, v) {
    var want = Object.assign({}, c.sel); want[g.id] = v.v;
    var sel = resolveSel(c.fam, c.key, want); if (sel[g.id] !== v.v) return 0;
    if (c.custom) { var qt = cfQuote(S.cw, S.ch, sel.graphic); return qt.err ? 0 : qt.whole * 100; }
    var cb = comboOf(c.fam, c.key, sel), ps = packsFor(c.key, cb.code);
    return ps.length ? variantFor(c.key, cb.code, ps[0]).cents : 0;
  }
  // the price of the same order on another size (wall mount)
  function priceForKey(c, key) {
    var sel = resolveSel(c.fam, key, c.sel), cb = comboOf(c.fam, key, sel), ps = packsFor(key, cb.code);
    return ps.length ? variantFor(key, cb.code, ps[0]).cents : fromKey(key);
  }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function inchTxt(n) { return fmt(Math.round(n * 100) / 100); }
  function dimTxt(w, h) { return inchTxt(w) + ' x ' + inchTxt(h) + ' in'; }
  function ftTxt(n) { return fmt(Math.round(n / 12 * 100) / 100) + ' ft'; }
  // the size people know a product by: the display size (W x H x D) for displays, the frame (W x H, turned when hung
  // landscape) for wall mounts, the fabric size typed in for custom fabric
  function sizeName(key) {
    var e = KEYS[key] || {};
    if (isCustom(key)) return dimTxt(S.cw, S.ch);
    if (e.hw && e.hw.kind === 'seg-wall') {
      var w = num(e.hw.w, 0), h = num(e.hw.h, 0), land = S.sel && S.sel.orient === 'landscape' && turnable(key) && S.key === key;
      return land ? dimTxt(h, w) : dimTxt(w, h);
    }
    return e.size || key;
  }
  function pieceSize(g) { return dimTxt(g.W, g.H); }
  function visTxt(g) { return dimTxt(g.vis.w, g.vis.h); }
  function tplTxt(c) { return fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in'; }
  // the supplier wording of the value picked in a group with this role ('' = none)
  function selLabel(c, role) { var out = ''; c.fam.groups.forEach(function (g) { if (g.role === role && c.sel[g.id] != null) { var v = valOf(g, c.sel[g.id]); if (v) out = v.label; } }); return out; }
  function productLabel(c) { return c.fam.name || 'SEG display'; }
  function standLabel(c) { return productLabel(c); }
  function sizeLabel(c) {
    var g = c.sign.geo;
    if (c.custom) return 'Fabric ' + dimTxt(g.W, g.H) + ' (' + ftTxt(g.W) + ' x ' + ftTxt(g.H) + '), width x height';
    if (c.cat === 'wall') return 'Frame ' + sizeName(c.key) + ', width x height' + (c.orient === 'landscape' ? ' (hung landscape)' : '');
    return 'Display ' + sizeName(c.key) + ' (width x height x depth); graphic ' + pieceSize(g) + ' per side';
  }
  function pieceSizeLabel(c, p, f) { var g = isBack(f) && c.sides === 2 ? c.sign.bgeo : c.sign.geo; return 'print page ' + pieceSize(g) + ' (width x height)'; }
  function sidesLabel(c) { return c.sides === 2 ? 'Double sided (a front and a back graphic)' : 'Single sided' + (c.lit && !c.custom && c.e.hw && c.e.hw.blackoutBack ? ' (blackout back included)' : ''); }
  function orderLabel(c) { if (c.custom) return 'Fabric graphic only (no frame)'; return selLabel(c, 'order') || (c.order === 'GO' ? 'Graphic Only' : 'Graphic + Frame'); }
  function riderLabel() { return ''; }
  function hwLabel(c) {
    if (c.custom) return 'Not included: fabric graphic only. Use an SEG frame you already have, or have one built.';
    if (c.order === 'GO') return 'Not included: graphic only, for an SEG frame you already have';
    var hw = (c.e && c.e.hw) || {};
    if (hw.kind === 'seg-wall') return 'Black aluminum frame, about 1 in deep, with wall mounts and hardware';
    if (hw.kind === 'seg-popup') return 'Accordion-style popup frame with LED lighting';
    if (hw.lit) return 'Slim aluminum frame with LED lighting';
    return 'Quick-assembly aluminum frame' + (c.famId === 'nl3' ? ' and travel bag' : '');
  }
  function litLabel(c) {
    if (c.custom) return c.graphic === 'backlit' ? 'Backlit fabric (for a frame with lights)' : 'Non-lit fabric';
    if (!c.lit) return '';
    return c.order === 'GO' ? 'Backlit graphic (lights not included)' : 'LED lighting included';
  }
  function orientLabel(c) { return c.cat === 'wall' && turnable(c.key) ? (c.orient === 'landscape' ? 'Landscape (wider than tall)' : 'Portrait (taller than wide)') : ''; }
  function matLabel(c) { return (c.sign && c.sign.geo.material) || ''; }
  // every option group shown for this product, in the supplier's order and wording (written on the order as "Options")
  function optLines(c) {
    var out = [];
    if (c.custom) out.push(['Size', dimTxt(S.cw, S.ch)]);
    c.fam.groups.forEach(function (g) {
      if (c.sel[g.id] == null || !shows(g.when, c.sel)) return;
      if (g.role === 'orient' && !turnable(c.key)) return;
      if (g.spec || g.hidden) return; // not a supplier option (shown in the order details instead)
      var v = valOf(g, c.sel[g.id]); if (!v) return;
      out.push([g.label || GROUP_LABEL[g.role] || 'Option', v.label]);
    });
    return out;
  }
  function optText(c) { return optLines(c).map(function (l) { return l[0] + ': ' + l[1]; }).join('; '); }
  function qtyNoun(c, n) { var w = c.custom || c.order === 'GO' ? 'graphic' : 'display'; return n === 1 ? w : w + 's'; }
  function qtyLabel(n, c) { c = c || cfg(); return n + ' ' + qtyNoun(c, n); }
  function deliveryLabel(c) { return c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Free shipping anywhere in the US'; }
  function faceName(f) { return { front: 'Front', back: 'Back', 'rider-front': 'Rider front', 'rider-back': 'Rider back' }[normFace(f)]; }
  function frontLabel(c) { return c.sides === 2 ? 'Front' : (c.custom ? 'Fabric' : 'Graphic'); }
  function proofFaceLabel(c, f) {
    if (f === 'front') return frontLabel(c) + (c.sign.geo.panels.length ? ' (wraps around both sides)' : '');
    if (f === 'back') return c.bm.sign === 'different' ? 'Back (as seen from the back)' : (c.popBack ? 'Back: the front panel art again' : 'Back: same art as the front');
    return faceName(f);
  }
  // the faces the proof shows: the front, and the back of a double sided order (also when it repeats the front)
  function proofFaces(c) { return c.sides === 2 ? ['front', 'back'] : ['front']; }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new sign or rider size: keep the art, but fit it to the new template (Fill for pictures, Fit for files)
  function resetArt(piece) {
    FACES.forEach(function (f) { var a = ART[f]; if (a && pieceOf(f) === piece) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } });
  }
  function viewFor() { return S.back ? 'back' : 'front'; }
  // after a change: a rider face needs a rider, a back needs a 2-sided piece
  function fixFace() {
    var c = cfg();
    if (S.piece === 'rider' && !c.rider) { S.piece = 'sign'; S.face = 'front'; S.back = false; c = cfg(); }
    if (S.face === 'back' && c.pieceSides !== 2) { S.face = 'front'; S.back = false; }
  }
  // a new product: its first sign size
  function pickFamily(id) {
    var f = famOf(id), c = cfg(); if (!f.id || f.id === c.famId) return;
    var ks = keysShown(f); if (!ks.length) return;
    pickSign(ks[0], f.id);
  }
  // a new sign size (or product): keep the art, fit it again when the page changes
  function pickSign(key, famId) {
    key = normKey(key); if (!key) return;
    var c = cfg(); if (key === c.key) return;
    var a = KEYS[c.key], b = KEYS[key];
    var ga = geoFor(c.key, 'sign', '', false, c.orient), gb = geoFor(key, 'sign', '', false, c.orient), same = !!b && Math.abs(ga.W - gb.W) < 1e-6 && Math.abs(ga.H - gb.H) < 1e-6;
    if (!same) { resetArt('sign'); if (S.piece === 'sign') { lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; } }
    var rBefore = c.riderSize;
    Object.assign(S, { key: key, fam: famId || b.fam, artVer: S.artVer + 1 });
    var c2 = cfg();
    if (c2.riderSize !== rBefore && c2.riderSize) resetArt('rider');
    fixFace(); render();
    view3d(viewFor());
  }
  // a supplier option: keep every other pick that still applies
  function pickOpt(gid, v) {
    var c = cfg(); if (c.sel[gid] === v) return;
    var sel = Object.assign({}, S.sel, c.sel); sel[gid] = v;
    var rBefore = c.riderSize, sBefore = c.sides, pBefore = c.sign.Wi + 'x' + c.sign.Hi;
    Object.assign(S, { sel: sel, artVer: S.artVer + 1 });
    var c2 = cfg();
    if (c2.riderSize && c2.riderSize !== rBefore) {
      resetArt('rider');
      toast('Rider added. Pick "Rider" on the layout toolbar to design it.');
    }
    if (sBefore === 2 && c2.sides !== 2) S.backMode = 'same';
    if (c2.sign.Wi + 'x' + c2.sign.Hi !== pBefore) { resetArt('sign'); lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; } // wall mount turned: fit the art again
    fixFace(); render();
    view3d(viewFor());
  }
  // a new pack size keeps about the same number of signs (3 single signs -> 1 pack of 5; 2 packs of 25 -> 5 packs of 10)
  function pickPack(q) { q = +q; if (!q || q === S.pack) return; var c = cfg(), signs = c.qty * c.pack; set({ pack: q, qty: Math.max(1, Math.min(maxQty(q), Math.ceil(signs / q))) }); }
  function setQty(n) { n = Math.max(1, Math.min(maxQty(cfg().pack), Math.round(Number(n)) || 1)); if (n !== S.qty) set({ qty: n }); else render(); }
  // the back of a 2-sided piece: the same art as its front, or its own (piece: 'sign' | 'rider', default the piece shown)
  function pickBackMode(mode, piece) {
    var p = piece === 'rider' || piece === 'sign' ? piece : S.piece;
    var cur = p === 'rider' ? S.rBackMode : S.backMode;
    if (mode === cur) { if (mode === 'different' && (S.piece !== p || S.face !== 'back')) { S.piece = p; S.face = 'back'; S.back = true; render(); view3d('back'); } return; }
    var patch = { artVer: S.artVer + 1, piece: p };
    patch[p === 'rider' ? 'rBackMode' : 'backMode'] = mode;
    if (mode === 'different') { patch.face = 'back'; patch.back = true; } // go straight to the back so its art can be added
    else { patch.face = 'front'; patch.back = false; }
    set(patch);
    view3d(S.back ? 'back' : 'front');
  }
  // show (and edit) a face: switches the piece and side; false when this order has no such face
  function goFace(face) {
    var f = normFace(face), p = pieceOf(f), c = cfg();
    if (p === 'rider' && !c.rider) return false;
    var sides = p === 'rider' ? c.rsides : c.sides;
    if (isBack(f) && sides !== 2) return false;
    if (p !== S.piece) { lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; }
    set({ piece: p, face: isBack(f) ? 'back' : 'front', back: isBack(f) });
    view3d(viewFor());
    return true;
  }

  // ---------- artwork ----------
  // the art drawn on a face: a back with "Same as front" shows its piece's front art
  function backShown(p) { var c = cfg(), sd = p === 'rider' ? c.rsides : c.sides; return sd === 2 && c.bm[p] === 'different'; }
  function artFor(face) {
    var p = pieceOf(face);
    if (isBack(face) && backShown(p)) return ART[fid(p, 'back')];
    return ART[fid(p, 'front')];
  }
  // v2: text, clipart and logo layers added in the designer (ardor-realestate-layers-kit.js). Same face rule as artFor.
  function layerFace(face) { var p = pieceOf(face); return isBack(face) && backShown(p) ? fid(p, 'back') : fid(p, 'front'); }
  function hasLayers(f) { return !!(window.ArdorSegLayers && window.ArdorSegLayers.has(normFace(f))); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // Oct 12, 2026 (tpl): the cart refuses any add-to-cart request over 20 MB ("413 Request Entity Too Large"), and the
  // request holds the proof, the print file(s) and the customer's original upload(s). Keep the whole upload under
  // UPLOAD_BUDGET: print files first (made smaller when needed), then the proof, then the original files while they fit.
  // Same approach as assets/ardor-aframe-builder-v2-v2.js.
  var UPLOAD_BUDGET = 18 * 1024 * 1024;
  function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function decodeBlob(file) {
    if (window.createImageBitmap) return createImageBitmap(file);
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
      im.src = u;
    });
  }
  // re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
  function shrinkImage(file, maxBytes) {
    if (!file || file.size <= maxBytes) return Promise.resolve(file);
    return decodeBlob(file).then(function (bmp) {
      var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
      var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
      var attempt = function () {
        var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        if (!ctx) return Promise.reject(new Error('canvas'));
        ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bmp, 0, 0, w, h);
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
          cv.width = cv.height = 1;
          if (!b) throw new Error('could not make the print image');
          if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
          if (bmp.close) bmp.close();
          return new File([b], String(file.name || 'Ardor SEG Display Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
        });
      };
      return attempt();
    });
  }
  // the print file again from flattened images (one per printed face) of at most maxBytes in all
  function smallerSheet(c, maxBytes, approval) {
    var stamp = (approval && approval.when) || stampLabel(new Date()), n = sheetLayout(c).slots.length, notes = [];
    return makeSheet(c, stamp, function () { return null; }, notes, { maxBytes: Math.max(524288, Math.floor((maxBytes - 65536) / n)) });
  }
  // The cart refuses any add-to-cart request over 20 MB (413). Keep the whole upload under UPLOAD_BUDGET: the print file
  // first (made again from smaller flattened images when needed), then the proof, then the original files while they fit.
  function fitUpload(c, files, approval) {
    var faces = printedFaces(c);
    var size = function (b) { return b ? b.size : 0; };
    files.skipArt = {}; files.needEmail = false;
    var orig = function (f) { return ART[f] && ART[f].file ? ART[f].file : null; };
    var total = function () { return size(files.proof) + size(files.sheet) + faces.reduce(function (t, f) { return t + (files.skipArt[f] ? 0 : size(orig(f))); }, 0); };
    if (total() <= UPLOAD_BUDGET) return Promise.resolve(files);
    // 1. the print file gets what the proof leaves
    var share = Math.max(1572864, UPLOAD_BUDGET - size(files.proof) - 262144);
    var step = files.sheet && files.sheet.size > share ? smallerSheet(c, share, approval).then(function (nb) {
      if (nb && nb.size < files.sheet.size) {
        files.notes.push('The print file was made from lower resolution images (' + fmtMB(files.sheet.size) + ' to ' + fmtMB(nb.size) + ') to fit the 20 MB online order upload limit.');
        files.sheet = nb;
      }
    }, function () { return null; }) : Promise.resolve();
    return step.then(function () {
      // 2. the customer's original files, while they still fit
      var used = size(files.proof) + size(files.sheet);
      faces.forEach(function (f) {
        var o = orig(f); if (!o) return;
        if (used + o.size <= UPLOAD_BUDGET) { used += o.size; return; }
        files.skipArt[f] = true;
        if (!files.sheet) files.needEmail = true;
        files.notes.push('The customer\'s original ' + faceName(f).toLowerCase() + ' file (' + (ART[f].name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files.sheet ? ' The print file has the full design.' : ' The customer was asked to email it.'));
      });
      // 3. last resort: a print file that could not be made small enough stays out
      if (total() > UPLOAD_BUDGET && files.sheet) {
        files.notes.push('The print file (' + fmtMB(files.sheet.size) + ') was too large to attach. Make it from the original artwork.');
        files.sheet = null;
        faces.forEach(function (f) { if (files.skipArt[f] || !orig(f)) files.needEmail = true; });
      }
      return files;
    });
  }
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (!hasLayers(f)) return Promise.resolve(mkJob(a));
    return window.ArdorSegLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorSegLayers; if (!LY || !LY.list) return '';
    var keys = printedFaces(c);
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? faceName(k) + ': ' : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  // art turned 90 or 270 degrees: its box is as wide as the picture is tall
  function rot90(a) { return !!a && (a.rot === 90 || a.rot === 270); }
  function geom(a, Wi, Hi) {
    var ia = rot90(a) ? a.natH / a.natW : a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW, rot: a.rot || 0 };
  }
  // draw a picture into its placed box g (the box of the art as turned), turned g.rot degrees clockwise
  function drawRot(ctx, img, g) {
    if (!g.rot) { ctx.drawImage(img, g.x, g.y, g.w, g.h); return; }
    var q = g.rot === 90 || g.rot === 270, dw = q ? g.h : g.w, dh = q ? g.w : g.h;
    ctx.save();
    ctx.translate(g.x + g.w / 2, g.y + g.h / 2);
    ctx.rotate(g.rot * Math.PI / 180);
    ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  function paintFace(ctx, Wi, Hi, face) {
    var cropped = popCrop(ctx, Wi, Hi, face); if (cropped != null) return cropped;
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorSegLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      drawRot(ctx, a.img, g);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorSegLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  // Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
  // as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
  // attached to the order.
  var ROT_NOTE = 'A photo carried a camera rotation tag, so the print file uses an upright copy of it.';
  function jpegOrientation(file) {
    return file.slice(0, 262144).arrayBuffer().then(function (ab) {
      var v = new DataView(ab), n = v.byteLength, p = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
      while (p + 4 <= n) {
        var m = v.getUint16(p);
        if ((m & 0xFF00) !== 0xFF00) return 1;
        if (m === 0xFFDA || m === 0xFFD9) return 1;
        var len = v.getUint16(p + 2);
        if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
          var t = p + 10, le = v.getUint16(t) === 0x4949;
          var ifd = t + v.getUint32(t + 4, le);
          if (ifd + 2 > n) return 1;
          var cnt = v.getUint16(ifd, le);
          for (var i = 0; i < cnt; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 12 > n) return 1;
            if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
          }
          return 1;
        }
        p += 2 + len;
      }
      return 1;
    }).catch(function () { return 1; });
  }
  function fixOrientation(a) {
    if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
    a.ready = jpegOrientation(a.file).then(function (o) {
      if (!(o >= 2 && o <= 8) || !a.img) return null;
      var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
      cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
      return new Promise(function (res) {
        cv.toBlob(function (b) {
          if (b) { a.printFile = new File([b], 'Ardor SEG Display Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
          cv.width = cv.height = 1; res(null);
        }, 'image/jpeg', 0.95);
      });
    }).catch(function () {});
  }

  // A file added while a Back tab shows "Same as front" is art for that back, so the piece switches to "Different back".
  // Returns the face id the file goes on.
  function uploadFace(file) {
    var c = cfg(), p = c.piece;
    if (S.face !== 'back') return fid(p, 'front');
    if (file && file.size <= MAX_FILE && c.pieceSides === 2 && c.bm[p] !== 'different') {
      if (p === 'rider') S.rBackMode = 'different'; else S.backMode = 'different';
      S.back = true; S.artVer++;
      toast('This art goes on the back. The front keeps its own art.');
    }
    return fid(p, 'back');
  }

  // Oct 12 (tpl): a finished template file (made on the template page of this face, so it has the page's shape within TPL_TOL)
  // is placed edge to edge on the whole page, bleed included, unturned
  var TPL_TOL = 0.01;
  function tplFit(a, face) {
    var c = cfg(fo(face));
    if (!a || !a.img || !(a.natW > 0) || !(a.natH > 0) || !(c.Wi > 0) || !(c.Hi > 0)) return false;
    if (Math.abs((a.natW / a.natH) / (c.Wi / c.Hi) - 1) > TPL_TOL) return false;
    a.mode = 'fill'; a.rot = 0; a.rcx = 0.5; a.rcy = 0.5; a.tpl = true;
    if (!/^ardor-ai-/.test(a.name || '')) toast('Template file detected - placed edge to edge'); // AI designs are page-sized too
    return true;
  }
  // Oct 20 2026 (upload bug, -up copy): uploaded artwork is painted UNDER the layers (paintFace), so on a face that holds a
  // Background layer (fabric.ArdorBg, full page, opaque) a new upload was completely hidden: on screen, in 3D, on the proof
  // and in the print file. how = 'ask' (customer uploads: file input, drop): the kit asks first (add it as a logo layer on
  // top, or replace the background); how = 'replace': the kit takes the background off this face, then the file becomes
  // its artwork as before; any other caller (AI designs: whole-display pictures) replaces the background with a message.
  // Faces without a background: unchanged. Same fix as the real estate designer (assets/ardor-realestate-builder.js).
  function loadFile(file, face, how) {
    face = normFace(face);
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var KT = window.ArdorSegKit, over = KT && KT.designFor ? KT.designFor(face) : null;
    if (over && how === 'ask' && KT.askUpload) {
      KT.askUpload({ file: file, face: face, preview: function () { return loadArtView().then(function (av) { return av.preview(file, { maxPx: 2400 }); }); }, replace: function () { loadFile(file, face, 'replace'); } });
      return;
    }
    if (over && KT.clearDesign) KT.clearDesign(face, how === 'replace' ? 'ask' : 'ai');
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF', rot: 0 };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500; fixOrientation(a);
      ART[face] = a; tplFit(a, face); S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      var fk = FACES.filter(function (k) { return ART[k] === a; })[0]; if (fk) { tplFit(a, fk); S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your display, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your display.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your display.' + tail;
  }
  function needsEmailProof() {
    return printedFaces(cfg()).some(function (f) { var x = ART[f]; return x && x.noPreview; });
  }

  // ---------- flat sign drawing (2D editor, 3D faces and proof) ----------
  function polyPath(ctx, p) { if (!p || !p.length) return; ctx.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) ctx.lineTo(p[i][0], p[i][1]); ctx.closePath(); }
  var checkerCv = null;
  function checker(ctx, u) {
    try {
      if (!checkerCv) {
        checkerCv = document.createElement('canvas'); checkerCv.width = checkerCv.height = 16;
        var x = checkerCv.getContext('2d'); x.fillStyle = '#ECECEF'; x.fillRect(0, 0, 16, 16); x.fillStyle = '#DADADF'; x.fillRect(0, 0, 8, 8); x.fillRect(8, 8, 8, 8);
      }
      var pat = ctx.createPattern(checkerCv, 'repeat');
      if (pat && pat.setTransform && window.DOMMatrix) { pat.setTransform(new DOMMatrix().scale(u * 0.75)); return pat; }
    } catch (e) {}
    return '#E6E6EA';
  }
  // a label centered in a box, at least about 9 screen pixels high, shrunk to fit the box's width
  function zoneLabel(ctx, txt, x, y, w, h, u) {
    if (!txt) return;
    var turn = h > w * 2.5, L = turn ? h : w, T = turn ? w : h;
    if (T / u < 6) return; // thinner than 6 screen pixels: no room for a label
    ctx.save();
    ctx.font = '700 1px Arial, sans-serif';
    var tw = ctx.measureText(txt).width || txt.length * 0.6;
    var fs = Math.max(Math.min(T * 0.5, (L * 0.86) / tw, 3), u * 9);
    if (tw * fs > L * 0.98) fs = (L * 0.98) / tw;
    if (fs / u < 6) { ctx.restore(); return; }
    ctx.translate(x + w / 2, y + h / 2); if (turn) ctx.rotate(-Math.PI / 2);
    ctx.font = '700 ' + fs + 'px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.lineJoin = 'round'; ctx.lineWidth = fs * 0.28; ctx.strokeStyle = 'rgba(30,31,36,0.85)'; ctx.strokeText(txt, 0, 0);
    ctx.fillStyle = 'rgba(255,255,255,0.96)'; ctx.fillText(txt, 0, 0);
    ctx.restore();
  }
  // the guides on one face: outside the visible area dimmed, the silicone edge band greyed (it goes into the frame),
  // the 2 in bleed zone tinted (background only, may be trimmed), popup folds (dashed) and panel names, the visible
  // area's edge and the dashed red safe line(s). u = inches per screen pixel (line widths).
  function drawGuides(ctx, c, Wi, Hi, face, u) {
    var G = faceGeo(c, face), v = G.vis, z = G.zone || 0;
    ctx.save();
    ctx.setLineDash([]);
    if (v.x > 0.001 || v.y > 0.001 || v.w < Wi - 0.002 || v.h < Hi - 0.002) {
      ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.rect(v.x, v.y, v.w, v.h);
      ctx.globalAlpha = 0.55; ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd'); ctx.globalAlpha = 1;
    }
    // the bleed zone: a light blue band between the page edge and the line z inches inside it
    if (z > 0 && Wi > 2 * z && Hi > 2 * z) {
      ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.rect(z, z, Wi - 2 * z, Hi - 2 * z);
      ctx.fillStyle = 'rgba(37,99,235,0.10)'; ctx.fill('evenodd');
      ctx.beginPath(); ctx.rect(z, z, Wi - 2 * z, Hi - 2 * z);
      ctx.setLineDash([u * 2, u * 3]); ctx.lineWidth = u; ctx.strokeStyle = 'rgba(37,99,235,0.6)'; ctx.stroke(); ctx.setLineDash([]);
      var eb = Math.max(0, Hi - v.y - v.h);
      zoneLabel(ctx, 'BLEED ZONE: BACKGROUND ONLY', z, Hi - z, Wi - 2 * z, z - eb, u);
    }
    G.hidden.forEach(function (zz) {
      ctx.fillStyle = 'rgba(52,54,62,0.62)'; ctx.fillRect(zz.x, zz.y, zz.w, zz.h);
      ctx.lineWidth = u; ctx.strokeStyle = 'rgba(255,255,255,0.45)'; ctx.strokeRect(zz.x, zz.y, zz.w, zz.h);
    });
    var said = {};
    G.hidden.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; }).forEach(function (zz) {
      var t = String(zz.why || 'Silicone edge').toUpperCase(); if (said[t]) return; said[t] = 1;
      zoneLabel(ctx, t, zz.x, zz.y, zz.w, zz.h, u);
    });
    // popups: fold lines and the panel names in the top band
    G.folds.forEach(function (x) {
      ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, Hi);
      ctx.setLineDash([u * 7, u * 4]); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(12,13,13,0.75)'; ctx.stroke(); ctx.setLineDash([]);
    });
    if (G.panels.length) {
      var top = v.y, bh = Math.max(0, (z || 2) - top);
      G.panels.forEach(function (p) { zoneLabel(ctx, String(p.label || '').replace(/\s*\(.*\)\s*$/, '').toUpperCase(), p.x, top, p.w, bh, u); });
    }
    ctx.beginPath(); ctx.rect(v.x, v.y, v.w, v.h);
    ctx.lineWidth = u * 1.4; ctx.strokeStyle = 'rgba(12,13,13,0.9)'; ctx.stroke();
    G.safe.forEach(function (p) {
      ctx.beginPath(); polyPath(ctx, p);
      ctx.setLineDash([]); ctx.lineWidth = u * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)'; ctx.stroke();
      ctx.setLineDash([u * 6, u * 4]); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)'; ctx.stroke();
    });
    ctx.setLineDash([]);
    ctx.restore();
  }
  function drawFlat(ctx, c, Wi, Hi, face, guides, u) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, face), tall = G.bh > G.bw * 1.6;
      ctx.save();
      ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2);
      if (tall) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork goes here', 0, 0);
      ctx.restore();
    }
    if (!guides) return;
    drawGuides(ctx, c, Wi, Hi, face, u || Math.max(Wi, Hi) / 600);
  }

  // ---------- flat layout editor: the whole template fits the stage; zoom in and pan to work on part of it ----------
  // lay.scale = screen px per inch, lay.ox / lay.oy = where the page's top-left corner sits on the canvas (css px),
  // lay.zoom 1 = whole page, lay.cx / lay.cy = the view's center in page fractions when zoomed in.
  var lay = { canvas: null, scale: 1, drag: false, pan: false, hand: false, lx: 0, ly: 0, zoom: 1, cx: 0.5, cy: 0.5, ox: 0, oy: 0 };
  var ZMAX = 8;
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 520;
    var fit = Math.min(maxW / Wi, maxH / Hi), z = fit * lay.zoom;
    var cssW = Math.max(1, Math.round(Math.min(Wi * z, maxW))), cssH = Math.max(1, Math.round(Math.min(Hi * z, maxH)));
    var hx = cssW / (2 * z * Wi), hy = cssH / (2 * z * Hi);
    lay.cx = hx >= 0.5 ? 0.5 : clamp(lay.cx, hx, 1 - hx);
    lay.cy = hy >= 0.5 ? 0.5 : clamp(lay.cy, hy, 1 - hy);
    lay.ox = cssW / 2 - lay.cx * Wi * z; lay.oy = cssH / 2 - lay.cy * Hi * z;
    lay.scale = z; lay.fit = fit;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    var kx = cv.width / cssW, ky = cv.height / cssH;
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z * kx, 0, 0, z * ky, lay.ox * kx, lay.oy * ky);
    drawFlat(ctx, c, Wi, Hi, fid(c.piece, S.face), true, 1 / z);
    syncZoomUi();
    try { root.dispatchEvent(new CustomEvent('ardor:seg-view')); } catch (e) {}
  }
  function syncZoomUi() {
    var out = $('[data-abb-zoom2d-val]'); if (out) out.textContent = Math.round(lay.zoom * 100) + '%';
    var zi = $('[data-abb-zoom2d-in]'), zo = $('[data-abb-zoom2d-out]'), zf = $('[data-abb-zoom2d-fit]'), hb = $('[data-abb-hand]');
    var zoomed = lay.zoom > 1.001;
    if (!zoomed) lay.hand = false;
    if (zi) zi.disabled = lay.zoom >= ZMAX - 0.001;
    if (zo) zo.disabled = !zoomed;
    if (zf) zf.disabled = !zoomed;
    if (hb) { hb.hidden = !zoomed; hb.setAttribute('aria-pressed', lay.hand ? 'true' : 'false'); }
    if (lay.canvas) lay.canvas.style.cursor = lay.hand ? 'grab' : '';
    root.classList.toggle('abb--hand', !!lay.hand);
  }
  // zoom to z (1 = whole page); (px, py) = the canvas point (css px) that stays put, else the view's center
  function setZoom(z, px, py) {
    var c = cfg(), Z = clamp(z, 1, ZMAX);
    if (px != null && lay.scale > 0) {
      var ux = (px - lay.ox) / lay.scale / c.Wi, uy = (py - lay.oy) / lay.scale / c.Hi, z1 = lay.fit * Z;
      var cw = lay.canvas ? parseFloat(lay.canvas.style.width) || 0 : 0, ch = lay.canvas ? parseFloat(lay.canvas.style.height) || 0 : 0;
      lay.cx = ux + (cw / 2 - px) / (z1 * c.Wi); lay.cy = uy + (ch / 2 - py) / (z1 * c.Hi);
    }
    lay.zoom = Z;
    drawLayout();
  }
  function panBy(dx, dy) { var c = cfg(); lay.cx -= dx / (lay.scale * c.Wi); lay.cy -= dy / (lay.scale * c.Hi); drawLayout(); }
  // turn the art on the face being edited 90 degrees (d = 90 right, -90 left) around its center, keeping its size
  function rotateArt(d) {
    var a = editingArt(); if (!a || !a.img) return;
    var c = cfg(), g = geom(a, c.Wi, c.Hi);
    a.rot = (((a.rot || 0) + d) % 360 + 360) % 360;
    if (a.mode === 'custom') a.rw = g.h / c.Wi;
    S.artVer++; render();
  }

  function editingArt() { var c = cfg(); return S.face === 'back' ? (c.pieceSides === 2 && c.backMode === 'different' ? ART[fid(c.piece, 'back')] : null) : ART[fid(c.piece, 'front')]; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    // drag the art to move it. Zoomed in: drag outside the art (or with the hand tool on) to move the view.
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(), c = cfg(), zoomed = lay.zoom > 1.001, onArt = false;
      if (a && a.img && !lay.hand) {
        if (!zoomed) onArt = true;
        else {
          var g = geom(a, c.Wi, c.Hi), r = cv.getBoundingClientRect();
          var ux = (e.clientX - r.left - lay.ox) / lay.scale, uy = (e.clientY - r.top - lay.oy) / lay.scale;
          onArt = ux >= g.x && ux <= g.x + g.w && uy >= g.y && uy <= g.y + g.h;
        }
      }
      if (!onArt && !zoomed) return;
      lay.drag = onArt; lay.pan = !onArt; lay.lx = e.clientX; lay.ly = e.clientY;
      if (lay.pan) cv.style.cursor = 'grabbing';
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (lay.pan) { var px = e.clientX - lay.lx, py = e.clientY - lay.ly; lay.lx = e.clientX; lay.ly = e.clientY; panBy(px, py); return; }
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { var was = lay.pan; lay.drag = false; lay.pan = false; if (was) syncZoomUi(); };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    // mouse wheel / trackpad over the stage: pinch or Ctrl + wheel zooms, the wheel moves the view when zoomed in
    cv.parentNode.addEventListener('wheel', function (e) {
      var r = cv.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top;
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); setZoom(lay.zoom * Math.pow(0.996, e.deltaY), px, py); return; }
      if (lay.zoom <= 1.001) return;
      e.preventDefault();
      panBy(-(e.shiftKey ? e.deltaY : e.deltaX), -(e.shiftKey ? 0 : e.deltaY));
    }, { passive: false });
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    on('[data-abb-rot-l]', 'click', function () { rotateArt(-90); });
    on('[data-abb-rot-r]', 'click', function () { rotateArt(90); });
    on('[data-abb-zoom2d-in]', 'click', function () { setZoom(lay.zoom * 1.5); });
    on('[data-abb-zoom2d-out]', 'click', function () { setZoom(lay.zoom / 1.5); });
    on('[data-abb-zoom2d-fit]', 'click', function () { lay.cx = 0.5; lay.cy = 0.5; setZoom(1); });
    on('[data-abb-hand]', 'click', function () { lay.hand = !lay.hand; syncZoomUi(); });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber)
  function resIssue(a, c) {
    if (!a || !a.img || a.kind !== 'image' || /svg/i.test(a.file.type || a.name)) return null;
    var g = geom(a, c.Wi, c.Hi), ppi = Math.round(a.natW / (rot90(a) ? g.h : g.w));
    if (ppi < 40) return { level: 'bad', text: ' is only about ' + ppi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or pick a smaller size.' };
    if (ppi < 75) return { level: 'soft', text: ' is about ' + ppi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.' };
    return null;
  }

  function updateArtUi() {
    fixFace();
    var c = cfg();
    var two = c.pieceSides === 2, backDiff = two && c.backMode === 'different';
    var a = editingArt();
    var tabs = $('[data-abb-art-tabs]'); if (tabs) tabs.hidden = !two && !c.rider;
    $$('[data-abb-piece]').forEach(function (pb) { pb.hidden = !c.rider; pb.setAttribute('aria-pressed', pb.getAttribute('data-abb-piece') === c.piece ? 'true' : 'false'); });
    $$('[data-abb-face]').forEach(function (fb) { fb.hidden = !two; fb.setAttribute('aria-pressed', fb.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var lab = c.rider ? (c.piece === 'rider' ? 'rider ' : 'sign ') : '';
    var sameBack = S.face === 'back' && !backDiff;
    $('[data-abb-drop]').hidden = sameBack;
    var upl = $('[data-abb-upload-label]'); if (upl) upl.textContent = S.face === 'back' ? 'Upload art for the ' + lab + 'back' : (c.piece === 'rider' ? 'Upload rider artwork' : 'Upload artwork');
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var msg = '', level = '';
    if (sameBack) { empty.hidden = false; empty.textContent = 'The ' + lab + 'back shows the same art as the ' + lab + 'front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so your print will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.face === 'back' ? 'No art for the ' + lab + 'back yet. Upload it above.' : (c.piece === 'rider' ? 'No rider artwork yet. Upload yours above.' : 'No artwork yet. Upload yours above.'); }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
    }
    // image resolution on every printed face; the worst one is shown, in the footer, where it is always in view
    var faces = printedFaces(c), worst = null;
    faces.forEach(function (f) {
      var r = resIssue(ART[f], cfg(fo(f)));
      if (r && (!worst || (r.level === 'bad' && worst.r.level !== 'bad'))) worst = { f: f, r: r };
    });
    if (worst) { msg = (faces.length > 1 ? 'The image for the ' + faceName(worst.f).toLowerCase() : 'This image') + worst.r.text; level = worst.r.level; }
    [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el) {
      if (!el) return;
      el.hidden = !msg; el.textContent = msg;
      if (msg && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
    });
  }

  // ---------- render ----------
  function specLines(c) {
    var out = [['Product', productLabel(c)], ['Size', sizeLabel(c)], ['Hardware', orderLabel(c)], ['Sides', sidesLabel(c)]];
    var hw = hwLabel(c); if (hw) out.push(['Frame', hw]);
    var lt = litLabel(c); if (lt) out.push(['Lighting', lt]);
    var ol = orientLabel(c); if (ol) out.push(['Hang it', ol]);
    var mn = matLabel(c); if (mn) out.push(['Material', mn]);
    out.push(['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    return out;
  }
  // small product icons for the product cards (24 x 40)
  var SIL = {
    nonlit: '<rect x="3" y="4" width="18" height="26" rx="1" fill="currentColor" opacity=".85"/><path d="M5 30v6M19 30v6M2 37h8M14 37h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    backlit: '<rect x="3" y="4" width="18" height="26" rx="1" fill="currentColor" opacity=".85"/><path d="M7 9h10M7 13h10M7 17h10" stroke="#fff" stroke-width="1.2" opacity=".7"/><path d="M5 30v6M19 30v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    popup: '<path d="M2 8l4-3h12l4 3v24l-4 3H6l-4-3z" fill="currentColor" opacity=".85"/><path d="M6 5v30M18 5v30" stroke="#fff" stroke-width="1.2" opacity=".6"/>',
    wall: '<path d="M1 3h22" stroke="currentColor" stroke-width="1.2" opacity=".5"/><rect x="4" y="8" width="16" height="24" rx="1" fill="none" stroke="currentColor" stroke-width="2"/><rect x="6" y="10" width="12" height="20" fill="currentColor" opacity=".8"/>',
    fabric: '<path d="M4 6c4-2 12 2 16 0v28c-4 2-12-2-16 0z" fill="currentColor" opacity=".85"/><path d="M4 6v28M20 6v28" stroke="currentColor" stroke-width="1.6"/>'
  };
  function famIcon(id) {
    var f = famOf(id);
    return '<svg class="abb-opt__sil" viewBox="0 0 24 40" width="22" height="36" aria-hidden="true" focusable="false">' + (SIL[f.cat] || SIL.nonlit) + '</svg>';
  }
  // a short help line under a supplier option group
  function groupNote(c, g) {
    if (g.role === 'size') return c.cat === 'wall' ? 'Frame size, width x height.' + (c.order === 'GO' ? ' Pick the size of the frame you have.' : '') : (c.custom ? '' : 'Display size: ' + sizeName(c.key) + ' (width x height x depth).');
    if (g.role === 'order') return c.order === 'GO' ? 'Graphic Only: a new printed fabric graphic for an SEG frame you already have.' : 'The printed fabric graphic with its frame' + (c.lit ? ' and LED lighting' : '') + '.';
    if (g.role === 'sides') {
      if (c.custom || c.cat === 'wall') return '';
      if (c.sides === 2) return 'Printed on the front and the back: two fabric graphics.' + (c.popBack ? ' The back covers the front panel only.' : ' Use the same art on both, or give the back its own.');
      return 'Printed on the front.' + (c.lit && c.e.hw && c.e.hw.blackoutBack ? ' A blackout back is included.' : '');
    }
    if (g.role === 'orient') return c.orient === 'landscape' ? 'Same price. Your fabric is still made ' + dimTxt(c.sign.geo.W0, c.sign.geo.H0) + ', with your art turned to fit.' : 'Same price either way. Landscape hangs the frame on its side (wider than tall).';
    if (g.role === 'lit') return c.graphic === 'backlit' ? 'Backlit: for frames with lights inside.' : 'Non-lit: for frames without lights.';
    return '';
  }
  function packNudge() {}
  function renderGroup(slot, c, g) {
    var vis = shows(g.when, c.sel) && g.role !== 'custom' && !g.hidden && !(g.role === 'orient' && !turnable(c.key));
    slot.hidden = !vis;
    slot.setAttribute('data-abb-group', g.id);
    var tEl = $('[data-abb-opt-title]', slot); if (tEl) tEl.textContent = g.label || GROUP_LABEL[g.role] || 'Option';
    // the option list and its note are found by the slot number: the app layout moves them into its option rows
    var idx = slot.getAttribute('data-abb-optstep'), box = $('[data-abb-opt="' + idx + '"]'), note = $('[data-abb-opt-note="' + idx + '"]');
    if (!box) return;
    if (!vis) { fill(box, []); if (note) note.textContent = ''; return; }
    var vals = realVals(g).filter(function (v) { return g.role === 'size' ? (v.key && keysShown(c.fam).indexOf(v.key) >= 0) : valShows(c.key, g, v, c.sel); });
    var single = vals.length < 2, nodes = [], same = g.role === 'orient';
    g.values.forEach(function (v) {
      if (v.hdr) { if (!single) { var h = document.createElement('span'); h.className = 'abb-opt-hdr'; h.textContent = v.label; nodes.push(h); } return; }
      if (vals.indexOf(v) < 0) return;
      if (v.head && !single) { var hh = document.createElement('span'); hh.className = 'abb-opt-hdr'; hh.textContent = v.head; nodes.push(hh); } // the supplier's headings in a list ("Standard Size", "Square")
      var on, cents, data, pick;
      if (g.role === 'size') { on = v.key === c.key; cents = priceForKey(c, v.key); data = ['sign', v.key]; pick = function () { pickSign(v.key); }; }
      else { on = c.sel[g.id] === v.v; cents = priceWith(c, g, v); data = [g.id, v.v]; pick = function () { pickOpt(g.id, v.v); }; }
      var html = '<span class="abb-opt__name">' + esc(v.label) + '</span>' + (single ? '' : '<span class="abb-opt__price">' + (same ? 'Same price' : (cents > 0 ? money(cents / 100) : 'Call us')) + '</span>');
      var b = optBtn({ chip: single, on: on, data: data, disabled: !single && !(cents > 0), html: html, pick: pick });
      if (g.role === 'size') b.setAttribute('data-size', v.v);
      nodes.push(b);
    });
    slot.classList.toggle('abb-step--fixed', single);
    box.className = 'abb-opts ' + (single ? 'abb-opts--chips' : (g.role === 'size' ? 'abb-opts--cards abb-opts--sizes' : 'abb-opts--two'));
    fill(box, nodes);
    if (note) note.textContent = groupNote(c, g);
  }

  function render() {
    var c = cfg();
    var p = price(c);
    S.fam = c.famId; S.key = c.key;
    if (c.custom && !CFP) loadCfp().catch(function () {});

    // 1. product: one card per product with its icon and its lowest price
    fill($('[data-abb-shapes]'), famsShown().map(function (f) {
      var lo = famFrom(f);
      var html = famIcon(f.id) + '<span class="abb-opt__name">' + esc(f.name).replace(/(\S+-\S+)/g, '<span class="abb-nw">$1</span>') + '</span><span class="abb-opt__sub">' + esc(f.sub || '') + '</span><span class="abb-opt__price">' + (lo > 0 ? 'from ' + money(lo / 100) : 'Call us') + '</span>';
      return optBtn({ on: f.id === c.famId, html: html, data: ['fam', f.id], pick: function () { pickFamily(f.id); } });
    }));

    // custom fabric: the size typed in, its price, the fabric-only note and the measuring guide
    var cfw = $('[data-abb-cf-wrap]');
    if (cfw) {
      cfw.hidden = !c.custom;
      if (c.custom) {
        var wi = $('[data-abb-cf-w]'), hi = $('[data-abb-cf-h]'), er = $('[data-abb-cf-err]');
        if (wi && document.activeElement !== wi && !(er && !er.hidden)) wi.value = fmt(S.cw);
        if (hi && document.activeElement !== hi && !(er && !er.hidden)) hi.value = fmt(S.ch);
        setText('[data-abb-cf-ft]', '= ' + ftTxt(S.cw) + ' x ' + ftTxt(S.ch) + (c.cf && c.cf.sqft ? ' (' + fmt(c.cf.sqft) + ' sq ft)' : ''));
        setText('[data-abb-cf-price]', c.cf && !c.cf.err ? money(c.cf.whole) + ' each for this size, ' + (c.graphic === 'backlit' ? 'backlit' : 'non-lit') : '');
      }
    }

    // 2. the supplier's option groups for this product, in their order and wording (one slot each)
    var slots = $$('[data-abb-optstep]'), gi = 0;
    c.fam.groups.forEach(function (g) { var slot = slots[gi++]; if (slot) renderGroup(slot, c, g); });
    for (; gi < slots.length; gi++) { var ix = slots[gi].getAttribute('data-abb-optstep'), nt = $('[data-abb-opt-note="' + ix + '"]'); slots[gi].hidden = true; slots[gi].removeAttribute('data-abb-group'); fill($('[data-abb-opt="' + ix + '"]'), []); if (nt) nt.textContent = ''; }

    // 3. the back: the same art as the front, or a different back
    var bWrap = $('[data-abb-sides-wrap]'); if (bWrap) bWrap.hidden = c.sides !== 2;
    var sBox = $('[data-abb-sides]'); if (sBox) { sBox.hidden = true; fill(sBox, []); }
    setText('[data-abb-sides-note]', c.sides === 2 ? (c.popBack ? 'The back covers the front panel only (no side returns). Use the front panel art again, or give the back its own.' : 'Show the same art on both sides, or give the back its own.') : '');
    var bmWrap = $('[data-abb-backmode-wrap]'); if (bmWrap) bmWrap.hidden = c.sides !== 2;
    fill($('[data-abb-backmodes]'), c.sides === 2 ? [
      optBtn({ chip: true, on: c.bm.sign !== 'different', data: ['backmode', 'same'], label: 'Same as front', pick: function () { pickBackMode('same', 'sign'); } }),
      optBtn({ chip: true, on: c.bm.sign === 'different', data: ['backmode', 'different'], label: 'Different back', pick: function () { pickBackMode('different', 'sign'); } })
    ] : []);
    var rbWrap = $('[data-abb-rbackmode-wrap]'); if (rbWrap) rbWrap.hidden = true;

    // 4. quantity: 1 to MAX_QTY displays (more is a quote)
    var pkWrap = $('[data-abb-packs-wrap]'); if (pkWrap) pkWrap.hidden = true;
    var qIn = $('[data-abb-qty]'); if (qIn && document.activeElement !== qIn) qIn.value = String(c.qty);
    if (qIn) { qIn.setAttribute('aria-label', 'Number of ' + qtyNoun(c, 2)); qIn.max = String(MAX_QTY); }
    var qm = $('[data-abb-qty-minus]'), qp = $('[data-abb-qty-plus]'); if (qm) qm.disabled = c.qty <= 1; if (qp) qp.disabled = c.qty >= MAX_QTY;
    setText('[data-abb-qty-unit]', qtyNoun(c, c.qty));
    setText('[data-abb-qty-note]', c.qty > 1 ? c.qty + ' ' + qtyNoun(c, c.qty) + ' at ' + money(p.each) + ' each: ' + money(p.charged) + '. All have the same art.' : money(p.each) + ' each.');

    // 5. delivery: free shipping or free pickup
    fill($('[data-abb-delivery]'), [
      optBtn({ on: c.delivery === 'ship', data: ['delivery', 'ship'], html: '<span class="abb-opt__name">Ship it to me (free)</span><span class="abb-opt__sub">Free shipping anywhere in the US</span>', pick: function () { set({ delivery: 'ship' }); } }),
      optBtn({ on: c.delivery === 'pickup', data: ['delivery', 'pickup'], html: '<span class="abb-opt__name">Pick up at our Snohomish shop (free)</span><span class="abb-opt__sub">' + esc(PICKUP) + '</span>', pick: function () { set({ delivery: 'pickup' }); } })
    ]);

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box: the total, then quantity x price
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2;
    eachEl.textContent = qtyLabel(c.qty, c) + ' x ' + money(p.each);
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var dl = c.delivery === 'pickup' ? 'Free pickup at our Snohomish shop' : 'Free shipping anywhere in the US';
    setText('[data-abb-free]', dl + '. You approve your proof before checkout.' + (c.custom ? ' Fabric only - no frame included.' : ''));
    $$('[data-abb-dnote]').forEach(function (el) { el.textContent = c.delivery === 'pickup' ? 'Free pickup' : 'Free shipping'; });

    // summary chips, the tip on the stage and the 3D tools
    setText('[data-abb-chip-size]', c.custom ? 'Custom SEG Fabric ' + dimTxt(S.cw, S.ch) : productLabel(c) + (c.cat === 'wall' ? ' ' + sizeName(c.key) : ''));
    setText('[data-abb-chip-mat]', c.sides === 2 ? 'Double sided' : 'Single sided');
    setText('[data-abb-chip-sides]', qtyLabel(c.qty, c) + (c.order === 'GO' && !c.custom ? ' (graphic only)' : ''));
    var G = c.geo, tip = 'Keep text and logos inside the red line.';
    if (G.zone > 0) tip += ' Run your background to the edge: the blue band is the bleed zone.';
    if (G.hidden.length) tip += ' The grey edge goes into the frame.';
    if (G.folds.length) tip += ' Dashed lines are folds: the sides wrap around.';
    if (c.custom) tip = 'Fabric only - no frame included. ' + tip;
    setText('[data-abb-tip]', tip);
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');
    root.setAttribute('data-abb-stand', c.key);
    root.setAttribute('data-abb-piece-on', 'sign');
    root.setAttribute('data-abb-fam', c.famId);

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorSeg3D, three.js). Everything else works without it. ----------
  // ---------- 3D viewer (window.ArdorSeg3D, three.js). Everything else works without it. ----------
  var faceCv = {}, faceSent = {}, engSent = '', syncQueued = false;
  // one face for the 3D view: the whole page of that face as printed (the 3D shows what the frame leaves)
  function paintFaceCanvas(c, face) {
    face = normFace(face);
    if (pieceOf(face) === 'rider') return null;
    var pc = cfg(fo(face)), Wi = pc.Wi, Hi = pc.Hi, k = Math.min(40, 2048 / Math.max(Wi, Hi));
    var w = Math.max(2, Math.round(Wi * k)), h = Math.max(2, Math.round(Hi * k));
    var cv = faceCv[face] || (faceCv[face] = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    ctx.setTransform(w / Wi, 0, 0, h / Hi, 0, 0);
    drawFlat(ctx, pc, Wi, Hi, face, false);
    return cv;
  }
  function sendFace(face, cv) {
    var key = cv ? cv.width + 'x' + cv.height + '|' + engSent : 'none|' + engSent;
    if (faceSent[face] === key) return;
    faceSent[face] = key;
    eng.setFace(face, cv || null);
  }
  function pieceFor3d(g, sides) {
    return { tpl: { w: g.W, h: g.H }, visible: [g.vis.x, g.vis.y, g.vis.w, g.vis.h], hidden: g.hidden.map(function (z) { return { rect: [z.x, z.y, z.w, z.h], why: z.why, kind: z.k }; }),
      faces: sides, holes: [], flutes: null, panels: g.panels.map(function (p) { return { id: p.id, x: p.x, w: p.w, label: p.label }; }), folds: g.folds.slice() };
  }
  // the 3D display gets the product, hardware, sides, orientation and both pages (seg/core/3D-CONTRACT.md), then the
  // printed page of each face (the back only on double sided orders: the front art again, or its own art)
  function sync3d() {
    if (!eng) return;
    var c = cfg();
    try {
      var key = [c.key, c.order, c.combo, c.sides, c.orient, c.custom ? S.cw + 'x' + S.ch + c.graphic : ''].join('|');
      if (key !== engSent) {
        engSent = key;
        var hw = Object.assign({}, (c.e && c.e.hw) || {});
        // hardware stays as listed (W x H); orient says how it hangs, and the page sent is already turned to match it
        if (c.custom) { hw.w = c.sign.geo.W; hw.h = c.sign.geo.H; hw.lit = c.graphic === 'backlit'; }
        var disp = pieceFor3d(c.sign.geo, c.sides);
        eng.set({ key: c.key, family: c.famId, cat: c.cat, order: c.order, faces: c.sides, sides: c.sides, lit: !!hw.lit, orient: c.orient,
          display: disp, sign: disp, back: c.sides === 2 ? pieceFor3d(c.sign.bgeo, 2) : null, hardware: hw,
          custom: c.custom ? { w: c.sign.geo.W, h: c.sign.geo.H } : null, rider: null });
      }
      sendFace('front', paintFaceCanvas(c, 'front'));
      sendFace('back', c.sides === 2 ? paintFaceCanvas(c, 'back') : null);
      eng.refresh();
    } catch (e) {}
    syncLights(c);
  }
  function sync3dSoon() {
    if (!eng || syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } }
  // lit displays: a Lights on / off button on the 3D toolbar when the 3D engine can switch its lights
  function syncLights(c) {
    var b = $('[data-abb-lights]'); if (!b) return;
    c = c || cfg();
    var can = !!(eng && typeof eng.lights === 'function') && c.lit;
    b.hidden = !can;
    if (!can) return;
    var onNow = true; try { onNow = eng.lights() !== false; } catch (e) {}
    b.textContent = onNow ? 'Lights off' : 'Lights on';
    b.setAttribute('aria-pressed', onNow ? 'true' : 'false');
  }
  function startEngine() {
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorSeg3D && host) ? window.ArdorSeg3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
  }

  // ---------- proof sheet and print files ----------
  // one face for the proof: its piece's whole template page with the guides
  // QA Oct 20, 2026: the double sided print file as ONE proof drawing: each face's proof picture (art + guides) placed
  // where sheetLayout puts it on the one page (stacked, or side by side on the 3 ft; popups: the back under the front
  // panel, the unprinted corners grey), labelled as one file
  function proofSheetFace(c, pf) {
    var L = sheetLayout(c), names = proofFaces(c);
    if (!L || !L.slots || L.slots.length < 2 || !(L.W > 0) || !(L.H > 0)) return null;
    var long = 1800, cw, ch;
    if (L.W >= L.H) { cw = long; ch = Math.max(60, Math.round(long * L.H / L.W)); } else { ch = long; cw = Math.max(60, Math.round(long * L.W / L.H)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d'), kx = cw / L.W, ky = ch / L.H, drew = 0;
    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, cw, ch);
    var dl = (c.e && c.e.doubleLayout) || null;
    ((dl && dl.grey) || []).forEach(function (r) { if (r && r.length === 4) { ctx.fillStyle = '#E4E2DE'; ctx.fillRect(r[0] * kx, r[1] * ky, r[2] * kx, r[3] * ky); } });
    L.slots.forEach(function (sl) {
      var f = pf[names.indexOf(sl.face)], src = f && (f.fallback || f.canvas);
      if (!src || !(f.wIn > 0) || !(f.hIn > 0)) return;
      ctx.drawImage(src, sl.x * kx, sl.y * ky, f.wIn * kx, f.hIn * ky); drew++;
    });
    if (drew !== L.slots.length) return null;
    var side = L.kind === 'side';
    return { label: 'One print file: ' + (side ? 'front on the left, back on the right' : 'front on top, back below'), canvas: cv, fallback: null, wIn: L.W, hIn: L.H, wLabel: fmt(L.W) + ' in', hLabel: fmt(L.H) + ' in', underlay: null };
  }
  function proofCanvas(face, overlayOnly) {
    var fk = normFace(face), c = cfg(fo(fk)), Wi = c.Wi, Hi = c.Hi;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var drewArt = overlayOnly || paintFace(ctx, Wi, Hi, fk);
    if (overlayOnly && hasLayers(layerFace(fk))) window.ArdorSegLayers.paint(ctx, Wi, Hi, layerFace(fk));
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, fk);
      ctx.save(); ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2); if (G.bh > G.bw * 1.6) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork', 0, 0); ctx.restore();
    }
    var u = Math.max(Wi, Hi) / long; // inches per canvas pixel
    drawGuides(ctx, c, Wi, Hi, fk, u * 2.4);
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var r = a.rot || 0, ia = rot90(a) ? nh / nw : nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi, rot: r };
      var fw0 = Math.min(Wi, Hi * ia), fh0 = fw0 / ia;
      return { x: (Wi - fw0) / 2, y: (Hi - fh0) / 2, w: fw0, h: fh0, rot: r, note: 'The uploaded PDF is a different shape than the print page, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, rot: r };
  }

  function loadPdfTool() {
    if (window.ArdorSegPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorSegPDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    var turn = a.rot === 90 ? ', turned 90 degrees right' : (a.rot === 270 ? ', turned 90 degrees left' : (a.rot === 180 ? ', turned upside down' : ''));
    if (a.mode === 'fill') return (a.tpl ? 'Template file, placed edge to edge' + (c && c.sign && c.sign.geo && c.sign.geo.zone > 0 ? ' (bleed zone included)' : '') : 'Fill the page (edges may crop)') + turn;
    if (a.mode === 'fit') return 'Fit whole image' + turn + ', background ' + a.bg;
    var g = geom(a, c.Wi, c.Hi);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from the page top-left' + turn + ', background ' + a.bg;
  }
  function artName(f) { var a = ART[f]; return a ? a.name : (hasLayers(f) ? 'Text and clipart added in the designer' : ''); }
  function artworkLabel() { var al = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; return artName('front') || (al ? 'From a link: ' + al.url : 'None'); }
  function backLabel(p) { return S.backMode === 'different' ? (artName('back') || 'Different art') : (cfg().popBack ? 'Same as front (the front panel art)' : 'Same as front'); }
  // the proof legend: what the guides on this order's pages mean
  function legendText(c) {
    var g = c.sign.geo, out = [];
    if (g.hidden.length) out.push('Grey edge: the silicone edge (it goes into the frame).');
    if (g.zone > 0) out.push('Blue band: the ' + fmt(g.zone) + ' in bleed zone (background only; it may be trimmed).');
    if (g.folds.length) out.push('Dashed black lines: the folds (the sides wrap around the frame).');
    out.push('Black line: the visible area. Dashed red line: keep text and logos inside it.');
    if (c.custom) out.push('Fabric only - no frame included.');
    return out.join(' ');
  }
  function placementFor(f) { var pc = cfg(fo(f)); return placementText(ART[f], pc); }
  // the print file: ONE page in the supplier's template layout. Single sided = the front page (a wall mount hung
  // landscape: the listed W x H page, the art turned 90 degrees clockwise). Double sided = the front and the back on one
  // page as the supplier's double template has them (stacked; side by side for the 3 ft; popups: the back under the front
  // panel only, the side areas left white). s = the template scale (the 20 ft is drawn at 50%). Inches, y down.
  function sheetLayout(c) {
    var e = c.e || {}, fg = c.sign.geo, two = c.sides === 2, dl = two ? (e.doubleLayout || null) : null;
    var s = num(dl && dl.scale, num(e.tplScale, 1)) || 1, slots = [], W, H, kind = 'single';
    if (!two) {
      W = fg.turned ? fg.H : fg.W; H = fg.turned ? fg.W : fg.H;
      slots.push({ face: 'front', x: 0, y: 0, g: fg, turn: !!fg.turned });
    } else {
      var bg = c.sign.bgeo; kind = (dl && dl.kind) || 'stack';
      var fp = dl && dl.front ? dl.front : [0, 0];
      var bp = dl && dl.back ? dl.back : (kind === 'side' ? [fg.W, 0] : [(fg.W - bg.W) / 2, fg.H]);
      W = dl && +dl.W > 0 ? +dl.W : (kind === 'side' ? fg.W + bg.W : Math.max(fg.W, bg.W));
      H = dl && +dl.H > 0 ? +dl.H : (kind === 'side' ? Math.max(fg.H, bg.H) : fg.H + bg.H);
      slots.push({ face: 'front', x: +fp[0] || 0, y: +fp[1] || 0, g: fg, turn: false }, { face: 'back', x: +bp[0] || 0, y: +bp[1] || 0, g: bg, turn: false });
    }
    return { W: W, H: H, s: s, slots: slots, kind: kind };
  }
  function printSizeText(c) {
    var L = sheetLayout(c), t;
    if (L.slots.length === 1) t = 'one ' + dimTxt(L.W, L.H) + ' page' + (L.slots[0].turn ? ', the art turned 90 degrees clockwise (the frame hangs landscape)' : '');
    else t = 'one ' + dimTxt(L.W, L.H) + ' page: front ' + pieceSize(c.sign.geo) + (L.kind === 'side' ? ' on the left, back ' + pieceSize(c.sign.bgeo) + ' on the right' : ' on top, back ' + pieceSize(c.sign.bgeo) + (c.popBack ? ' below it, under the front panel (the side areas are not printed)' : ' below it'));
    if (L.s !== 1) t += '; drawn at ' + Math.round(L.s * 100) + '% scale (' + dimTxt(L.W * L.s, L.H * L.s) + ' file page), print at ' + Math.round(100 / L.s) + '%';
    return t;
  }
  function proofSpecs(c) {
    var out = specLines(c).filter(function (l) { return l[0] !== 'Delivery' && l[0] !== 'Quantity'; });
    out.push(['Options', optText(c)]);
    out.push(['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    out.push(['Artwork', artworkLabel()]);
    var pl = placementFor('front'); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', backLabel('sign')]);
    if (c.sides === 2 && c.bm.sign === 'different') { var pb = placementFor('back'); if (pb) out.push(['Back placement', pb]); }
    out.push(['Print size', printSizeText(c)]);
    var added = layerSummary(c); if (added) out.push(['Added in the designer', added]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js): the 3D view on page 1, the pages next to it or on page 2 ----------
  function proofViews(c) {
    var out = [];
    try { sync3d(); } catch (e) {}
    if (!eng || typeof eng.snapshot !== 'function') return out;
    var lit = c.lit && typeof eng.lights === 'function', was = null;
    if (lit) { try { was = eng.lights() !== false; eng.lights(true); } catch (e) {} }
    [['home', 'From the front' + (lit ? ', lights on' : '')], (c.sides === 2 ? ['back', 'From the back'] : ['side', 'From the side'])].forEach(function (v) {
      try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
    });
    if (lit && was === false) { try { eng.lights(false); } catch (e) {} }
    return out;
  }
  function proofSheet(P, c, mode, o) {
    var PS = window.ArdorProofSheet;
    if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
    o.noun = c.qty > 1 ? 'SEG displays' : 'SEG display'; o.preview = mode === 'preview'; o.views = proofViews(c);
    return PS.build(o).catch(function () { return P.buildProof(o); });
  }
  // the print file (see sheetLayout): each face is its artwork placed as in the designer (one flattened image when it
  // has text, clipart, a QR code or a background), clipped to its own page. flat = { maxBytes } makes every face one
  // flattened image of at most maxBytes (to fit the cart upload limit).
  function makeSheet(c, date, vectorArt, notes, flat) {
    var P = window.ArdorSegPDF, LY = window.ArdorSegLayers, L = sheetLayout(c), s = L.s, comp = {}, arts = {};
    var jobs = L.slots.map(function (sl) {
      var g = sl.g, same = sl.face === 'back' && !backShown('sign');
      var src = same ? 'front' : sl.face, a = ART[src], pg = same ? c.sign.geo : g, off = [sl.x, sl.y];
      if (same && (Math.abs(pg.W - g.W) > 0.01 || Math.abs(pg.H - g.H) > 0.01)) { var cr = g.fromFront || [(pg.W - g.W) / 2, (pg.H - g.H) / 2]; off = [sl.x - cr[0], sl.y - cr[1]]; }
      // a box on the face's page (inches) -> the file page (turned for a landscape wall mount, then scaled)
      var X = function (r) {
        var o = sl.turn ? { x: pg.H - r.y - r.h, y: r.x, w: r.h, h: r.w, rot: ((r.rot || 0) + 90) % 360 } : { x: r.x, y: r.y, w: r.w, h: r.h, rot: r.rot || 0 };
        return { x: (off[0] + o.x) * s, y: (off[1] + o.y) * s, w: o.w * s, h: o.h * s, rot: o.rot, note: r.note };
      };
      var clip = sl.turn ? [0, 0, L.W * s, L.H * s] : [sl.x * s, sl.y * s, g.W * s, g.H * s];
      var bg = (a && a.bg) || '#FFFFFF';
      if (flat || hasLayers(src) || !a) {
        if (!comp[src]) {
          comp[src] = (LY && LY.composite ? LY.composite(src, pg.W, pg.H, a) : Promise.reject(new Error('print tools not loaded'))).then(function (r) {
            return flat ? shrinkImage(r.file, flat.maxBytes) : r.file;
          }).then(function (file) { return { file: file, name: file.name, kind: 'image' }; });
        }
        return comp[src].then(function (art) {
          if (hasLayers(src) && notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
          return { art: art, bg: '#FFFFFF', clip: clip, geomFor: function () { return X({ x: 0, y: 0, w: pg.W, h: pg.H, rot: 0 }); } };
        });
      }
      if (a.rotated && notes.indexOf(ROT_NOTE) < 0) notes.push(ROT_NOTE);
      var art = arts[src] || (arts[src] = a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a));
      return Promise.resolve({ art: art, bg: bg, clip: clip, geomFor: function (nw, nh) { return X(geomForArt(a, nw, nh, pg.W, pg.H)); } });
    });
    return Promise.all(jobs).then(function (faces) {
      return P.buildSheet({ title: 'Ardor SEG Display Print File', stamp: date, W: L.W * s, H: L.H * s, faces: faces });
    }).then(function (r) { (r.notes || []).forEach(function (n) { if (notes.indexOf(n) < 0) notes.push(n); }); return r.blob; });
  }
  function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorSegPDF;
      var faces = printedFaces(c);
      var out = { notes: [], proof: null, sheet: null };
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (!a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      // turned PDF/AI art shows on the proof from its drawn preview (the shared proof sheet places vector art unturned)
      var mkProofFace = function (label, f, a) {
        var pc = cfg(fo(f)), Wi = pc.Wi, Hi = pc.Hi;
        var va = a && !a.rot ? vectorArt(a) : null;
        return { label: label, canvas: proofCanvas(f, !!va), fallback: va ? proofCanvas(f, false) : null, wIn: Wi, hIn: Hi, wLabel: fmt(Wi) + ' in', hLabel: fmt(Hi) + ' in', underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      // a back with "Same as front" is drawn from the front art (no underlay of its own)
      var pfaces = proofFaces(c).map(function (f) { return mkProofFace(proofFaceLabel(c, f), f, isBack(f) && !backShown('sign') ? null : ART[f]); });
      // QA Oct 20, 2026: a double sided order has ONE print file (front and back on one page, see sheetLayout), so the
      // proof gets that page as one drawing (the shared proof sheet counts its faces as print files)
      if (pfaces.length > 1) { var onePage = null; try { onePage = proofSheetFace(c, pfaces); } catch (e) { onePage = null; } if (onePage) pfaces = [onePage]; }
      var date = (approval && approval.when) || stampLabel(new Date());
      var go = c.order === 'GO', many = c.qty > 1;
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor SEG Display Proof', panelTitle: c.custom ? 'Your SEG fabric (fabric only, no frame)' : ((many ? 'Your SEG displays' : 'Your SEG display') + (go ? ' (graphic only)' : '')), sideBySide: c.sides === 2 && c.sign.geo.H > c.sign.geo.W * 1.6,
          legend: legendText(c) + ' Print file (width x height): ' + printSizeText(c) + '.',
          approval: approval || null, date: date, faces: pfaces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var printable = function (f) { var a = ART[f]; return a ? (a.kind === 'image' || !!vectorArt(a) || (hasLayers(f) && !!a.img)) : hasLayers(f); };
      var printP = Promise.resolve();
      if (proofMode === 'preview') { /* PDF button: the proof only, no print file */ } else if (!faces.every(printable)) out.notes.push('The print file was not made automatically for this file type. Use the original artwork file.');
      else {
        if (faces.some(function (f) { return ART[f] && ART[f].src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        printP = makeSheet(c, date, vectorArt, out.notes).then(function (b) { out.sheet = b; }, function (e) { out.sheet = null; out.notes.push('The print file could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; out.faces = faces; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_seg_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_seg_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = proofFaces(c).map(function (f) { return [proofFaceLabel(c, f), f, isBack(f) && !backShown('sign') ? null : ART[f]]; });
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your SEG display proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + pieceSizeLabel(c, 'sign', f[1]) + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // One line: the variant (display, hardware and sides; custom fabric: the price holder's whole-dollar variant),
  // quantity = displays (or graphics), everything else as line item properties, including every option in the
  // supplier's wording ("Options"), the signed proof and ONE print file in the supplier's template layout.
  function setupMsg() { return 'Online ordering for this SEG display is being set up. Call ' + PHONE + ' or request a quote.'; }

  function addToCart() {
    showErr('');
    var c = cfg(); var p = price(c);
    if (c.custom && c.cf && c.cf.err) { showErr(c.cf.err); return; }
    if (c.custom && !CFP) { loadCfp().then(function () { addToCart(); }, function () { showErr(setupMsg()); }); return; }
    if (c.v.pending && !c.custom) { readLate(c.key, c.combo, c.pack).then(function () { addToCart(); }, function () { showErr(setupMsg()); }); return; }
    if (!p.vid || !c.v.available) { showErr(setupMsg()); return; }
    var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; // ART0 Oct 19 2026: artwork by link
    var faces = printedFaces(c);
    for (var i = 0; i < faces.length; i++) {
      var f = faces[i];
      if (ART[f] || hasLayers(f) || (f === 'front' && artLink)) continue;
      goFace(f);
      showErr(f === 'front' ? 'Upload your artwork first, or paste a link to it.' : 'Upload the art for the back, or choose "Same as front".');
      return;
    }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false, proofEmail = ''; // ART0: proofEmail
    var waits = FACES.map(function (k) { return ART[k]; }).filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof() || !!(artLink && !artLink.loaded); // ART0: a link we couldn't open = emailed proof
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      if (ap && ap.emailProof) { proofEmail = ap.email; emailProof = true; ap = null; } // ART0: "Email me the proof to approve"
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }); // stay under the cart's 20 MB upload limit
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      specLines(c).forEach(function (l) { fd.append('properties[' + l[0] + ']', l[1]); });
      fd.append('properties[Options]', optText(c));
      if (c.custom) {
        fd.append('properties[Graphic]', c.graphic === 'backlit' ? 'Backlit' : 'Non-Lit');
        fd.append('properties[Frame included]', 'No - fabric graphic only');
        fd.append('properties[_Custom price]', 'Formula ' + money(c.cf.cents / 100) + ' (' + fmt(c.cf.sqft) + ' sq ft), charged ' + money(c.cf.whole) + ' (next whole dollar), SKU ' + c.cf.sku);
      }
      fd.append('properties[Artwork]', artworkLabel());
      if (c.sides === 2) fd.append('properties[Back]', backLabel('sign'));
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      fd.append('properties[Designed in]', 'Ardor SEG Display Designer');
      if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
      if (proofEmail || (artLink && !artLink.loaded)) fd.append('properties[Proof approval]', 'Email - pending'); // ART0
      if (proofEmail) fd.append('properties[Proof email]', proofEmail); // ART0
      faces.forEach(function (f) { var pl = placementFor(f); if (pl) fd.append('properties[_' + faceName(f) + ' placement]', pl); });
      var added = layerSummary(c); if (added) fd.append('properties[_Added in the designer]', added);
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor SEG Display Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor SEG Display Proof'));
      else if (files.proof) fd.append('properties[_Ardor SEG Display Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor SEG Display Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', artLink && !artLink.loaded ? 'Ardor will build the proof from your link and email it to you to approve' : 'We\'ll email you a proof to approve before printing'); // ART0
      if (approval) {
        fd.append('properties[Approved by]', approval.name);
        fd.append('properties[Approved on]', approval.when);
        fd.append('properties[_Approver email]', approval.email);
        fd.append('properties[_Approver phone]', approval.phone);
      }
      if (files.sheet) {
        if (files.sheet.size <= MAXPDF) fd.append('properties[_Ardor SEG Print File - ' + labelStamp + ']', pdfFile(files.sheet, 'Ardor SEG Print File'));
        else files.notes.push('The print file was over 25 MB, so it was not attached. Use the original artwork file.');
      }
      var g = c.sign.geo, L = sheetLayout(c);
      var pnote = [(c.custom ? 'Custom SEG Fabric: ' : 'Display ' + c.key + ' (' + productLabel(c) + ', ' + sizeName(c.key) + '): ') + 'front page ' + pieceSize(g) + ', visible area ' + visTxt(g) + ' at ' + fmt(g.vis.x) + ', ' + fmt(g.vis.y) + ' in from the page top-left' + (g.hidden.length ? '; silicone edge band about ' + fmt(g.vis.x) + ' in' : '') + (g.zone ? '; bleed zone ' + fmt(g.zone) + ' in' : '') + (g.panels.length ? '; wrap panels ' + g.panels.map(function (pn) { return pn.label + ' x ' + fmt(pn.x) + ' to ' + fmt(pn.x + pn.w); }).join(', ') : '') + '.'];
      if (c.sides === 2) pnote.push('Back page ' + pieceSize(c.sign.bgeo) + (c.bm.sign === 'different' ? ': its own art (as seen from the back).' : (c.popBack ? ': the front panel art again.' : ': the same art as the front.')));
      pnote.push('Print file: ' + printSizeText(c) + '.');
      pnote.push('SKU ' + (c.v.sku || skuOf(c.key, c.combo, 1)) + '. Options: ' + optText(c) + '. Quantity: ' + qtyLabel(c.qty, c) + '. Delivery: ' + (c.delivery === 'pickup' ? 'pickup in Snohomish' : 'ship to the customer (blind ship)') + '.');
      if (c.custom) pnote.push('Custom size ' + dimTxt(S.cw, S.ch) + ', ' + (c.graphic === 'backlit' ? 'Backlit' : 'Non-Lit') + ' graphic; formula price ' + money(c.cf.cents / 100) + ', charged ' + money(c.cf.whole) + '. Fabric only - no frame.');
      if (files.sheet) pnote.push('The print file is the supplier template layout, art to the page edge (bleed zone included), no guides.');
      files.notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      var skipArt = files.skipArt || {};
      faces.forEach(function (f) {
        var a = ART[f]; if (!a || skipArt[f]) return;
        fd.append('properties[Ardor SEG Display Artwork ' + faceName(f) + ' - ' + labelStamp + ']', a.file, 'Ardor SEG Display Artwork ' + faceName(f) + ' ' + fileStamp + ext(a.name));
      });
      if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
      fd.append('properties[_spec]', JSON.stringify({ v: p.vid, sku: c.v.sku || '', key: c.key, combo: c.combo, s: c.sides, o: c.order, orient: c.orient, b: c.sides === 2 ? c.bm.sign : '', n: c.qty, each: p.each, total: p.charged, del: c.delivery, page: [g.W, g.H], vis: [g.vis.x, g.vis.y, g.vis.w, g.vis.h], bpage: c.sides === 2 ? [c.sign.bgeo.W, c.sign.bgeo.H] : null, sheet: [L.W * L.s, L.H * L.s], scale: L.s, cf: c.custom ? { w: S.cw, h: S.ch, g: c.graphic, cents: c.cf.cents, whole: c.cf.whole } : null }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      track('ardor_seg_added_to_cart', { value: p.charged, display: c.key, family: c.famId, combo: c.combo, order: c.order, quantity: c.qty });
      toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
      if (!CONF.stayOnPage) window.location.href = CONF.cartUrl || '/cart';
      else done();
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    lines.push('Options: ' + optText(c));
    printedFaces(c).forEach(function (f) { var a = ART[f]; if (a) lines.push(faceName(f) + ' artwork: ' + a.name + ' (I will send the file)'); });
    if (c.sides === 2) lines.push('Back: ' + backLabel('sign').toLowerCase());
    if (c.rider && c.rsides === 2) lines.push('Rider back: ' + backLabel('rider').toLowerCase());
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Online price shown: ' + money(p.charged) + ' (' + qtyLabel(c.qty, c) + ' x ' + money(p.each) + ')');
    return lines.join('\n');
  }

  function openQuote(want) {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText() + (typeof want === 'number' && want > MAX_QTY ? '\nQuantity wanted: ' + want : '');
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'SEG displays from the Ardor SEG Display Designer\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "Need more than 100, another size or a custom shape? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, uploadFace(f), 'ask'); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, uploadFace(f), 'ask'); });
      $$('[data-abb-face]').forEach(function (b) {
        b.addEventListener('click', function () {
          S.face = b.getAttribute('data-abb-face') === 'back' ? 'back' : 'front'; S.back = S.face === 'back';
          render(); view3d(S.back ? 'back' : 'front');
        });
      });
      // Sign / Rider: the piece being designed (the rider only when the order has one)
      $$('[data-abb-piece]').forEach(function (b) {
        b.addEventListener('click', function () {
          var pz = b.getAttribute('data-abb-piece') === 'rider' ? 'rider' : 'sign';
          if (pz === S.piece) return;
          goFace(fid(pz, 'front'));
        });
      });
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_seg_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindStand();
    bindCf();
    on('[data-abb-lights]', 'click', function () {
      if (!eng || typeof eng.lights !== 'function') return;
      var now = true; try { now = eng.lights() !== false; } catch (e) {}
      try { eng.lights(!now); } catch (e) {}
      syncLights();
    });
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // custom fabric: width and height in inches, checked against the limits as they are typed (a size we can't make is
  // changed to the nearest one we can when the field is left); the page, price and 3D follow
  function bindCf() {
    var wi = $('[data-abb-cf-w]'), hi = $('[data-abb-cf-h]'), er = $('[data-abb-cf-err]');
    if (!wi || !hi) return;
    var apply = function (final) {
      var w = parseFloat(wi.value), h = parseFloat(hi.value), msg = cfError(w, h);
      if (msg && final) {
        var fx = cfFix(w > 0 ? w : S.cw, h > 0 ? h : S.ch); w = fx[0]; h = fx[1]; msg = '';
        wi.value = fmt(w); hi.value = fmt(h);
        toast('Changed to the nearest size we can make: ' + dimTxt(w, h) + '.');
      }
      if (er) { er.hidden = !msg; er.textContent = msg; }
      if (msg) return;
      w = Math.round(w * 100) / 100; h = Math.round(h * 100) / 100;
      if (w === S.cw && h === S.ch) return;
      S.cw = w; S.ch = h; S.artVer++;
      resetArt('sign'); lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5;
      render(); view3d(viewFor());
    };
    [wi, hi].forEach(function (inp) {
      inp.addEventListener('input', function () { apply(false); });
      inp.addEventListener('change', function () { apply(true); });
    });
  }
  // quantity box, the "more than 10" quote link and the PDF proof button on the tool rail
  function bindStand() {
    var q = $('[data-abb-qty]');
    if (q) {
      q.addEventListener('input', function () { var v = parseInt(q.value, 10); if (v >= 1) setQty(Math.min(MAX_QTY, v)); if (v > MAX_QTY) { q.value = String(MAX_QTY); openQuote(v); } });
      q.addEventListener('change', function () { setQty(q.value); });
      q.addEventListener('blur', function () { render(); });
    }
    on('[data-abb-qty-minus]', 'click', function () { setQty(cfg().qty - 1); });
    on('[data-abb-qty-plus]', 'click', function () { setQty(cfg().qty + 1); });
  }
  // the shared proof sheet (assets/ardor-proofsheet.js) puts its PDF button on the rail for the builders it knows;
  // the SEG display designer adds the same button itself and opens the same preview window
  function mountPdf(tries) {
    var PS = window.ArdorProofSheet, B = window.ArdorSegBuilder, rail = $('.abx-rail');
    if (!PS || typeof PS.preview !== 'function' || !rail || !B || !B.proof) { if ((tries || 0) < 40) setTimeout(function () { mountPdf((tries || 0) + 1); }, 250); return; }
    if (B.proof._btn || $('[data-abb-pdf]', rail)) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg><span>PDF</span>';
    var qb = $('[data-abx-quote]', rail);
    if (qb && qb.nextSibling) rail.insertBefore(btn, qb.nextSibling); else rail.appendChild(btn);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); PS.preview(B.proof); });
    B.proof._btn = btn;
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    startEngine();
    window.ArdorSegBuilder = {
      state: S, specs: SPECS, fams: famsShown, keys: function (f) { return keysShown(famOf(f || cfg().famId)); }, live: function () { return LIVE; }, cfg: cfg, price: price, render: render,
      variantFor: variantFor, parseSku: parseSku, sku: skuOf, codes: codesFor, packs: packsFor, geo: faceGeo, viewer: function () { return eng; },
      proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); }, printedFaces: function () { return printedFaces(cfg()); },
      sheet: function () { return sheetLayout(cfg()); }, printSize: function () { return printSizeText(cfg()); }, specLines: function () { return specLines(cfg()); }, options: function () { return optText(cfg()); },
      pickFamily: pickFamily, pickSign: pickSign, pickOpt: pickOpt, pickBackMode: pickBackMode, goFace: goFace, setZoom: setZoom,
      setCustomSize: function (w, h) { var fx = cfFix(w, h); S.cw = fx[0]; S.ch = fx[1]; S.artVer++; resetArt('sign'); render(); return [S.cw, S.ch]; },
      customQuote: function (w, h, g) { return cfQuote(w, h, g); }, cfPrices: function () { return CFP; },
      faceCanvas: function (face) { return paintFaceCanvas(cfg(), face); },
      tplInfo: function () { var c = cfg(); return { key: c.key, product: productLabel(c), size: sizeLabel(c), sizeName: sizeName(c.key), sides: c.sides, sidesText: sidesLabel(c), rider: '', riderSides: 0, riderSize: '', Wi: c.sign.Wi, Hi: c.sign.Hi }; },
      layout: function () { return { zoom: lay.zoom, scale: lay.scale, ox: lay.ox, oy: lay.oy, cx: lay.cx, cy: lay.cy }; }
    };
    // used by ardor-seg-layers-kit.js and ardor-seg-kit.js. Sizes are in inches of the face being edited (c.Wi x c.Hi);
    // face ids 'front', 'back'. pageOf(face).piece is 'back' for the back page of a double sided order (popups: a
    // smaller page), so the layers of each page keep their own size.
    var safeOf = function (face) { var c = cfg(), f = face ? normFace(face) : fid(c.piece, S.face), g = faceGeo(c, f), r = g.safeR; return { x: r.x, y: r.y, w: Math.max(1, r.w), h: Math.max(1, r.h) }; };
    var infoOf = function (key) {
      var k = normKey(key); if (!k) return null;
      var e = KEYS[k], g = geoFor(k, 'sign', '', false, '');
      return { key: k, fam: e.fam, family: e.fam, group: e.fam, faces: +((e.front || e.sign || {}).faces) === 2 ? 2 : 1, name: famOf(e.fam).name + ', ' + sizeName(k), visible: { w: g.vis.w, h: g.vis.h }, page: { w: g.W, h: g.H }, riders: {} };
    };
    window.ArdorSegAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[normFace(face)] || null; },
      setArt: function (face, a) { ART[normFace(face)] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      piece: function () { return 'sign'; },
      face: function () { return fid('sign', S.face); },
      faces: function () { var c = cfg(); return c.sides === 2 ? ['front', 'back'] : ['front']; },
      printedFaces: function () { return printedFaces(cfg()); },
      // the face that can be edited now (null = a back showing "Same as front"); showFace = the face the layout shows
      // (a popup back with "Same as front" shows its own, empty layer set: its picture is the front panel)
      editFace: function () { var c = cfg(); if (S.face === 'back') return c.pieceSides === 2 && c.backMode === 'different' ? 'back' : null; return 'front'; },
      showFace: function () { var c = cfg(); return S.face === 'back' && c.pieceSides === 2 && (c.backMode === 'different' || c.popBack) ? 'back' : 'front'; },
      pageOf: function (face) { var f = normFace(face || 'front'), c = cfg(fo(f)); return { Wi: c.Wi, Hi: c.Hi, piece: isBack(f) && c.sides === 2 ? 'back' : 'sign' }; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; },
      // where the page sits on the 2D layout canvas (zoom and pan): z = css px per inch, ox / oy = page corner in css px
      layoutView: function () { return { z: lay.scale, ox: lay.ox, oy: lay.oy }; },
      // the visible area of a face, and the safe rect (new text, logos and QR codes go there; popups: the front panel)
      faceBox: function (face) { var c = cfg(), g = faceGeo(c, normFace(face || fid(c.piece, S.face))); return { x: g.vis.x, y: g.vis.y, w: g.vis.w, h: g.vis.h }; },
      pageBox: function (face) { var c = cfg(face ? fo(face) : {}); return { x: 0, y: 0, w: c.Wi, h: c.Hi }; },
      safeBox: safeOf,
      // the guides of the face shown (for the kit's background layer redraw)
      guides: function (face) { var c = cfg(), f = face ? normFace(face) : fid(c.piece, S.face), g = faceGeo(c, f); return { visible: [g.vis.x, g.vis.y, g.vis.w, g.vis.h], hidden: g.hidden.map(function (z) { return [z.x, z.y, z.w, z.h]; }), holes: [], keep: g.keep.map(function (z) { return [z.x, z.y, z.w, z.h]; }), safe: safeOf(f) }; },
      goFace: goFace, pickSign: pickSign, pickFamily: pickFamily, pickOpt: pickOpt, pickBackMode: pickBackMode,
      signKey: function () { return cfg().key; }, signInfo: infoOf, readVariant: readLate, maxQty: maxQty,
      signName: function () { var c = cfg(); return productLabel(c) + (c.custom || c.cat === 'wall' ? ', ' + sizeName(c.key) : ''); },
      signs: function () { var out = []; famsShown().forEach(function (f) { out = out.concat(keysShown(f)); }); return out; },
      // the designer's other names, for shared code written against the stand and real estate designers
      displayKey: function () { return cfg().key; }, standKey: function () { return cfg().key; }, standInfo: infoOf, pickStand: pickSign,
      standName: function () { var c = cfg(); return productLabel(c) + ', ' + sizeName(c.key); },
      stands: function () { var out = []; famsShown().forEach(function (f) { out = out.concat(keysShown(f)); }); return out; }
    };
    window.ArdorSegBuilder.proof = { noun: 'SEG displays', file: 'Ardor SEG Display Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
      var c = cfg(), waits = FACES.map(function (k) { return ART[k]; }).filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
      return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
    } };
    try { document.dispatchEvent(new CustomEvent('ardor:seg-api')); } catch (e) {}
    mountPdf(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
